import { Slide, ToastOptions } from "react-toastify"

export const IS_DEV_ENV_ENABLED: boolean = !process.env.NODE_ENV || process.env.NODE_ENV === "development"

/**************************************************************/
/**************************************************************/
/*                    BEGIN API-CORE CONSTANTS                */
/**************************************************************/
/**************************************************************/
/* HTTP Response custom codes to handle exceptions */
export const CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR = "FORM_VALIDATION_ERROR"

/* GENERAL */
export const CONST_CIVILITE_MR = "CIVILITE_MR"
export const CONST_CIVILITE_MME = "CIVILITE_MME"
export const CONST_CIVILITE_NON_RENSEIGNEE = "CIVILITE_NON_RENSEIGNEE"

/* ENTITY User*/
export const CONST_USER_ROLE_SUPER_ADMIN = "ROLE_SUPER_ADMIN"
export const CONST_USER_ROLE_IT = "ROLE_IT"
export const CONST_USER_ROLE_PRESIDENT = "ROLE_PRESIDENT"
export const CONST_USER_ROLE_DG = "ROLE_DG"
export const CONST_USER_ROLE_MANAGER = "ROLE_MANAGER"
export const CONST_USER_ROLE_RECRUTEUR = "ROLE_RECRUTEUR"
export const CONST_USER_ROLE_DAF = "ROLE_DAF"
export const CONST_USER_ROLE_RESPONSABLE_RH = "ROLE_RESPONSABLE_RH"
export const CONST_USER_ROLE_RH = "ROLE_RH"
export const CONST_USER_ROLE_COMPTABLE = "ROLE_COMPTABLE"
export const CONST_USER_ROLE_CHARGEE_COMMUNICATION = "ROLE_CHARGEE_COMMUNICATION"
export const CONST_USER_ROLE_AUTRE = "ROLE_AUTRE"
export const CONST_USER_ROLE_CANDIDAT = "ROLE_CANDIDAT"
export const CONST_USER_ROLE_CANDIDAT_EN_COURS_EMBAUCHE = "ROLE_CANDIDAT_EN_COURS_EMBAUCHE"
export const CONST_USER_ROLE_CONSULTANT = "ROLE_CONSULTANT"

export const CONST_USER_PERMISSION_UPDATES_VIEW = "PERMISSION_UPDATES_VIEW"
export const CONST_USER_PERMISSION_ANNUAIRE_VIEW = "PERMISSION_ANNUAIRE_VIEW"
export const CONST_USER_PERMISSION_GOOGLE_APPS_VIEW = "PERMISSION_GOOGLE_APPS_VIEW"
export const CONST_USER_PERMISSION_OUTILS_VIEW = "PERMISSION_OUTILS_VIEW"
export const CONST_USER_PERMISSION_OUTILS_COST_TOOL_VIEW = "PERMISSION_OUTILS_COST_TOOL_VIEW"
export const CONST_USER_PERMISSION_OUTILS_SIGNATURE_VIEW = "PERMISSION_OUTILS_SIGNATURE_VIEW"
export const CONST_USER_PERMISSION_OUTILS_EXPORTS_VIEW = "PERMISSION_OUTILS_EXPORTS_VIEW"
export const CONST_USER_PERMISSION_OUTILS_PDF_UTILS_VIEW = "PERMISSION_OUTILS_PDF_UTILS_VIEW"
export const CONST_USER_PERMISSION_TDB_VIEW = "PERMISSION_TDB_VIEW"
export const CONST_USER_PERMISSION_TDB_ALERTES_VIEW = "PERMISSION_TDB_ALERTES_VIEW"
export const CONST_USER_PERMISSION_TDB_INDICATEURS_VIEW = "PERMISSION_TDB_INDICATEURS_VIEW"
export const CONST_USER_PERMISSION_AI_USAGE_VIEW = "PERMISSION_AI_USAGE_VIEW"
export const CONST_USER_PERMISSION_DECLARATIONS_VIEW = "PERMISSION_DECLARATIONS_VIEW"
export const CONST_USER_PERMISSION_RECRUTEMENT_VIEW = "PERMISSION_RECRUTEMENT_VIEW"
export const CONST_USER_PERMISSION_RECRUTEMENT_ANNONCES_VIEW = "PERMISSION_RECRUTEMENT_ANNONCES_VIEW"
export const CONST_USER_PERMISSION_RECRUTEMENT_CANDIDATS_VIEW = "PERMISSION_RECRUTEMENT_CANDIDATS_VIEW"
export const CONST_USER_PERMISSION_RECRUTEMENT_VIVIERS_VIEW = "PERMISSION_RECRUTEMENT_VIVIERS_VIEW"
export const CONST_USER_PERMISSION_RECRUTEMENT_DEMANDE_EMBAUCHE_VIEW = "PERMISSION_RECRUTEMENT_DEMANDE_EMBAUCHE_VIEW"
export const CONST_USER_PERMISSION_BUSINESS_VIEW = "PERMISSION_BUSINESS_VIEW"
export const CONST_USER_PERMISSION_BUSINESS_PTF_VIEW = "PERMISSION_BUSINESS_PTF_VIEW"
export const CONST_USER_PERMISSION_BUSINESS_COLLAB_VIEW = "PERMISSION_BUSINESS_COLLAB_VIEW"
export const CONST_USER_PERMISSION_BUSINESS_CLIENT_VIEW = "PERMISSION_BUSINESS_CLIENT_VIEW"
export const CONST_USER_PERMISSION_BUSINESS_FOURNISSEUR_VIEW = "PERMISSION_BUSINESS_FOURNISSEUR_VIEW"
export const CONST_USER_PERMISSION_ADMINISTRATION_VIEW = "PERMISSION_ADMINISTRATION_VIEW"
export const CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_VIEW = "PERMISSION_ADMINISTRATION_PRODUCTION_VIEW"
export const CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_DECLARATIONS_VIEW = "PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_DECLARATIONS_VIEW"
export const CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_DDC_VIEW = "PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_DDC_VIEW"
export const CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_ARRETS_MALADIE_VIEW = "PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_ARRETS_MALADIE_VIEW"
export const CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_BL_VIEW = "PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_BL_VIEW"
export const CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_VIEW = "PERMISSION_ADMINISTRATION_STRUCTURE_VIEW"
export const CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW = "PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW"
export const CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_RESTRICTED = "PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_RESTRICTED"
export const CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_MANAGER = "PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_MANAGER"
export const CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_ADD_VIEW = "PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_ADD_VIEW"
export const CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_DECLARATIONS_VIEW = "PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_DECLARATIONS_VIEW"
export const CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_DDC_VIEW = "PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_DDC_VIEW"
export const CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_ARRETS_MALADIE_VIEW = "PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_ARRETS_MALADIE_VIEW"
export const CONST_USER_PERMISSION_ADMINISTRATION_ASSURANCES_VIEW = "PERMISSION_ADMINISTRATION_ASSURANCES_VIEW"
export const CONST_USER_PERMISSION_RESSOURCES_VIEW = "PERMISSION_RESSOURCES_VIEW"
export const CONST_USER_PERMISSION_RESSOURCES_BIBLIOTHEQUE_VIEW = "PERMISSION_RESSOURCES_BIBLIOTHEQUE_VIEW"
export const CONST_USER_PERMISSION_RESSOURCES_DOCUMENTS_EMBAUCHE_VIEW = "PERMISSION_RESSOURCES_DOCUMENTS_EMBAUCHE_VIEW"

/* ENTITY Annonce */
export const CONST_ANNONCE_ETAT_ON_CREATION = "ETAT_ON_CREATION"
export const CONST_ANNONCE_ETAT_ACTIVE = "ETAT_ACTIVE"
export const CONST_ANNONCE_ETAT_ARCHIVED = "ETAT_ARCHIVED"

/* ENTITY Personnel */
export const CONST_PERSONNEL_CODE_HUGO_DUTERTRE = "2412-3222-kda3-kmmm"
export const CONST_PERSONNEL_CODE_THOMAS_NAULEAU = "2222-1111-3333-aaaa"
export const CONST_PERSONNEL_CODE_CELINE_CORLE = "CELINE_CORLE"
export const CONST_PERSONNEL_CODE_DIDIER_BAGUR = "2222-8797-8999-aeds"
export const CONST_PERSONNEL_CODE_STAN_CABAUD = "STAN_CABAUD"
export const CONST_PERSONNEL_CODE_EMILIE_CR = "EMILIE_CR"
export const CONST_PERSONNEL_CODE_DAMIEN_BEU = "DAMIEN_BEU"
export const CONST_PERSONNEL_CODE_YASU = "5555-1222-aaaa-bbbb"
export const CONST_PERSONNEL_CODE_THOMAS_NAULLEAU = "2222-1111-3333-aaaa"

export const CONST_PERSONNEL_STATUT_STATUT_ETAM = "STATUT_ETAM"
export const CONST_PERSONNEL_STATUT_STATUT_AGENT_MAITRISE = "STATUT_AGENT_MAITRISE"
export const CONST_PERSONNEL_STATUT_STATUT_CADRE = "STATUT_CADRE"
export const CONST_PERSONNEL_STATUT_STATUT_NON_SALARIE = "STATUT_NON_SALARIE"
export const CONST_PERSONNEL_CONTRAT_CDI = "CONTRAT_CDI"
export const CONST_PERSONNEL_CONTRAT_CDD = "CONTRAT_CDD"
export const CONST_PERSONNEL_CONTRAT_NON_SALARIE = "CONTRAT_NON_SALARIE"
export const CONST_PERSONNEL_CONTRAT_STAGE = "CONTRAT_STAGE"
export const CONST_PERSONNEL_CONTRAT_ALTERNANCE = "CONTRAT_ALTERNANCE"

// ENTITY PersonnelApplicationAccess
export const CONST_PERSONNEL_APPLICATION_ACCESS_MODULE_ADMINISTRATIF = "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_ADMINISTRATIF"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MODULE_BUSINESS_PTF = "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BUSINESS_PTF"

/* ENTITY ConsultantDESuivi*/
export const CONST_CONSULTANT_DE_SUIVI_TYPE_BROUILLON = "TYPE_BROUILLON"
export const CONST_CONSULTANT_DE_SUIVI_TYPE_IA_RECTIFICATION_FOR_ADMIN = "TYPE_IA_RECTIFICATION_FOR_ADMIN"
export const CONST_CONSULTANT_DE_SUIVI_TYPE_IA_RECTIFICATION_FOR_DG = "TYPE_IA_RECTIFICATION_FOR_DG"
export const CONST_CONSULTANT_DE_SUIVI_TYPE_IA_RECTIFICATION_FOR_IARESP = "TYPE_IA_RECTIFICATION_FOR_IARESP"
export const CONST_CONSULTANT_DE_SUIVI_TYPE_IA_DEMANDE_EMBAUCHE = "TYPE_IA_DEMANDE_EMBAUCHE"
export const CONST_CONSULTANT_DE_SUIVI_TYPE_IARESP_VALIDATION = "TYPE_IARESP_VALIDATION"
export const CONST_CONSULTANT_DE_SUIVI_TYPE_IARESP_DEMANDE_RECTIFICATION = "TYPE_IARESP_DEMANDE_RECTIFICATION"
export const CONST_CONSULTANT_DE_SUIVI_TYPE_IARESP_REJET_DEFINITIF = "TYPE_IARESP_REJET_DEFINITIF"
export const CONST_CONSULTANT_DE_SUIVI_TYPE_DG_VALIDATION = "TYPE_DG_VALIDATION"
export const CONST_CONSULTANT_DE_SUIVI_TYPE_DG_DEMANDE_RECTIFICATION = "TYPE_DG_DEMANDE_RECTIFICATION"
export const CONST_CONSULTANT_DE_SUIVI_TYPE_DG_REJET_DEFINITIF = "TYPE_DG_REJET_DEFINITIF"
export const CONST_CONSULTANT_DE_SUIVI_TYPE_ADMIN_DEMANDE_RECTIFICATION = "TYPE_ADMIN_DEMANDE_RECTIFICATION"
export const CONST_CONSULTANT_DE_SUIVI_TYPE_ADMIN_VALIDATION = "TYPE_ADMIN_VALIDATION"

/* ENTITY PersonnelDdc */
export const CONST_PERSONNEL_DDC_TYPE_CONGES_PAYES = "TYPE_P_CONGES_PAYES"
export const CONST_PERSONNEL_DDC_TYPE_CONGES_SANS_SOLDE = "TYPE_P_CONGES_SANS_SOLDE"
export const CONST_PERSONNEL_DDC_TYPE_REPOS_COMPENSATEUR = "TYPE_P_REPOS_COMPENSATEUR"
export const CONST_PERSONNEL_DDC_TYPE_ABSENCE_AUTORISEE = "TYPE_P_ABSENCE_AUTORISEE"
export const CONST_PERSONNEL_DDC_TYPE_ABSENCE_NON_AUTORISEE = "TYPE_P_ABSENCE_NON_AUTORISEE"
export const CONST_PERSONNEL_DDC_TYPE_ABSENCE_EXCEPTIONNELLE = "TYPE_P_ABSENCE_EXCEPTIONNELLE"
export const CONST_PERSONNEL_DDC_TYPE_ABSENCE_RTT = "TYPE_P_ABSENCE_RTT"

export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_MARIAGE = "SOUS_TYPE_P_ABSENCE_EXCEPTIONNELLE_MARIAGE"
export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_PACS = "SOUS_TYPE_P_ABSENCE_EXCEPTIONNELLE_PACS"
export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_MARIAGE_ENFANT = "SOUS_TYPE_P_ABSENCE_EXCEPTIONNELLE_MARIAGE_ENFANT"
export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_CONGES_MATERNITE = "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_CONGES_MATERNITE"
export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_CONGES_PATERNITE_UN_ENFANT = "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_CONGES_PATERNITE_UN_ENFANT"
export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_CONGES_PATERNITE_MANY_ENFANT = "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_CONGES_PATERNITE_MANY_ENFANT"
export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_NAISSANCE_ENFANT = "SOUS_TYPE_P_ABSENCE_EXCEPTIONNELLE_NAISSANCE_ENFANT"
export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_ENFANT_MOINS_25_ANS = "SOUS_TYPE_P_ABSENCE_EXCEPTIONNELLE_DECES_ENFANT_MOINS_25_ANS"
export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_ENFANT_PLUS_25_ANS = "SOUS_TYPE_P_ABSENCE_EXCEPTIONNELLE_DECES_ENFANT_PLUS_25_ANS"
export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_CONJOINT_CONCUBUN_PARTENAIRE_PACS =
     "SOUS_TYPE_P_ABSENCE_EXCEPTIONNELLE_DECES_CONJOINT_CONCUBUN_PARTENAIRE_PACS"
export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_PARENT = "SOUS_TYPE_P_ABSENCE_EXCEPTIONNELLE_DECES_PARENT"
export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_PARENTS_CONJOINT_LIE_PAR_MARIAGE =
     "SOUS_TYPE_P_ABSENCE_EXCEPTIONNELLE_DECES_PARENTS_CONJOINT_LIE_PAR_MARIAGE"
export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_FRERE_SOEUR = "SOUS_TYPE_P_ABSENCE_EXCEPTIONNELLE_DECES_FRERE_SOEUR"
export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_BEAU_PERE_BELLE_MERE_DU_CONJOINT_MARIE_PACS =
     "SOUS_TYPE_P_ABSENCE_EXCEPTIONNELLE_DECES_BEAU_PERE_BELLE_MERE_DU_CONJOINT_MARIE_PACS"
export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_ANNONCE_HANDICAP_OU_MALADIE_GRAVE_ENFANT =
     "SOUS_TYPE_P_ABSENCE_EXCEPTIONNELLE_ANNONCE_HANDICAP_OU_MALADIE_GRAVE_ENFANT"
export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_GRAND_PARENT_OU_ARRIERE_GRAND_PARENT =
     "SOUS_TYPE_P_ABSENCE_EXCEPTIONNELLE_DECES_GRAND_PARENT_OU_ARRIERE_GRAND_PARENT"
export const CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_AUTRE = "SOUS_TYPE_P_ABSENCE_EXCEPTIONNELLE_AUTRE"

/* ENTITY PersonnelArretMaladie */
export const CONST_PERSONNEL_ARRET_MALADIE_MOTIF_MALADIE = "MALAD"
export const CONST_PERSONNEL_ARRET_MALADIE_MOTIF_ARRET_THERAPEUTIQUE = "ARRET_THERAPEUTIQUE"
export const CONST_PERSONNEL_ARRET_MALADIE_TYPE_TYPE_JOUR = "JOUR"
export const CONST_PERSONNEL_ARRET_MALADIE_TYPE_TYPE_DEMI_MATIN = "DEMI_MATIN"
export const CONST_PERSONNEL_ARRET_MALADIE_TYPE_TYPE_DEMI_APREM = "DEMI_APREM"
export const CONST_PERSONNEL_ARRET_MALADIE_TYPE_TYPE_AUTRE = "AUTRE"

// -- PersonnelDeclarationMensuelle
export const CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_INTERESSE_FINALISATION = "TYPE_INTERESSE_FINALISATION"
export const CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_INTERESSE_SIGNATURE = "TYPE_INTERESSE_SIGNATURE"
export const CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_INTERESSE_RECTIFICATION_SANS_DEMANDE = "TYPE_INTERESSE_RECTIFICATION_SANS_DEMANDE"
export const CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_RESP_DEMANDE_RECTIFICATION = "TYPE_RESP_DEMANDE_RECTIFICATION"
export const CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_RESP_VALIDATION = "TYPE_RESP_VALIDATION"
export const CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_SIEGE_DEMANDER_RECTIFICATION = "TYPE_SIEGE_DEMANDE_RECTIFICATION"
export const CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_SIEGE_VALIDATION = "TYPE_SIEGE_VALIDATION"
export const CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_INTERESSE_DEMANDE_REGUL = "TYPE_INTERESSE_DEMANDE_REGUL"
export const CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_RESP_VALIDATION_REGUL = "TYPE_RESP_VALIDATION_REGUL"
export const CONST_PERSONNEL_DECLARATION_SUIVI_TYPE_RESP_REJET_REGUL = "TYPE_RESP_REJET_REGUL"

/* ENTITY PersonnelCraDetails*/
export const CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_CPA = CONST_PERSONNEL_DDC_TYPE_CONGES_PAYES
export const CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_CSS = CONST_PERSONNEL_DDC_TYPE_CONGES_SANS_SOLDE
export const CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_CEX = CONST_PERSONNEL_DDC_TYPE_ABSENCE_EXCEPTIONNELLE
export const CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_CMA = "P_ABSCENCE_CMA"
export const CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_FERIES = "P_ABSCENCE_FERIES"
export const CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_REPOS_COMPENSATEUR = CONST_PERSONNEL_DDC_TYPE_REPOS_COMPENSATEUR
export const CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_SFP = "P_ABSCENCE_SFP"
export const CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_RTT = CONST_PERSONNEL_DDC_TYPE_ABSENCE_RTT
export const CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_AUTORISEE = CONST_PERSONNEL_DDC_TYPE_ABSENCE_AUTORISEE
export const CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_NON_AUTORISEE = CONST_PERSONNEL_DDC_TYPE_ABSENCE_NON_AUTORISEE

// ENTITY PersonnelCraDetailsHeures
export const CONST_PERSONNEL_CRA_DETAILS_HEURE_TYPE_DEFAULT = "TYPE_DEFAULT"
export const CONST_PERSONNEL_CRA_DETAILS_HEURE_TYPE_TT = "TYPE_TT"
export const CONST_PERSONNEL_CRA_DETAILS_HEURE_TYPE_ECOLE = "TYPE_ECOLE"

/* ENTITY PersonnelNdfDetail */
export const CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM = "CATEGORIE_KM"
export const CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_CARBURANT = "CATEGORIE_CARBURANT"
export const CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_PEAGE = "CATEGORIE_PEAGE"
export const CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_PARKING = "CATEGORIE_PARKING"
export const CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_AVION = "CATEGORIE_AVION"
export const CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_TRAIN = "CATEGORIE_TRAIN"
export const CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_TAXI = "CATEGORIE_TAXI"
export const CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_TRANSPORT_EN_COMMUN = "CATEGORIE_TRANSPORT_EN_COMMUN"
export const CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_HOTEL = "CATEGORIE_HOTEL"
export const CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_REPAS_MIDI = "CATEGORIE_REPAS_MIDI"
export const CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_FORFAIT_GRAND_DEPLACEMENT = "CATEGORIE_FORFAIT_GRAND_DEPLACEMENT"
export const CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_REPAS_SOIR = "CATEGORIE_REPAS_SOIR"
export const CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_DIVERS = "CATEGORIE_DIVERS"

// Entity PersonnelDdcSuivi
export const CONST_PERSONNEL_DDC_SUIVI_TYPE_ENVOI_DEMANDE = "TYPE_ENVOI_DEMANDE"
export const CONST_PERSONNEL_DDC_SUIVI_TYPE_RECTIFICATION_AVANT_DECISION_RESPONSABLE = "TYPE_RECTIFICATION_AVANT_DECISION_RESPONSABLE"
export const CONST_PERSONNEL_DDC_SUIVI_TYPE_ANNULATION_DEMANDE = "TYPE_ANNULATION_DEMANDE"
export const CONST_PERSONNEL_DDC_SUIVI_TYPE_ACCEPTATION_DEMANDE = "TYPE_ACCEPTATION_DEMANDE"
export const CONST_PERSONNEL_DDC_SUIVI_TYPE_REJET_DEMANDE = "TYPE_REJET_DEMANDE"

/* Entity PersonnelTemplate */
export const CONST_PERSONNEL_TEMPLATE_CATEGORIE_CODE_PERSONNEL_MAIL_TEMPLATE_TYPE_CANDIDAT_REFUS = "PERSONNEL_MAIL_TEMPLATE_TYPE_CANDIDAT_REFUS"
export const CONST_PERSONNEL_TEMPLATE_CATEGORIE_CODE_PARTAGER_DOCO_CANDIDAT_PAR_MAIL = "CONST_CODE_PARTAGER_DOCO_CANDIDAT_PAR_MAIL"
export const CONST_PERSONNEL_TEMPLATE_CATEGORIE_CODE_ENVOYER_DOCO_VIERGE_PAR_MAIL_A_REMPLIR_PAR_CANDIDAT = "CONST_CODE_ENVOYER_DOCO_VIERGE_PAR_MAIL_A_REMPLIR_PAR_CANDIDAT"
export const CONST_PERSONNEL_TEMPLATE_CATEGORIE_CODE_DMS = "CONST_CODE_DMS"
export const CONST_PERSONNEL_TEMPLATE_CATEGORIE_CODE_CANDIDAT_ENTRETIEN_EN_AGENCE = "CONST_CODE_CANDIDAT_ENTRETIEN_EN_AGENCE"
export const CONST_PERSONNEL_TEMPLATE_CATEGORIE_CODE_CANDIDAT_REUNION_QUALIF = "CONST_CODE_CANDIDAT_REUNION_QUALIF"

/* ENTITY PersonnelRechercheCandidatHistoriqueSauvegarde */
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_VISUALISATION_PASVUPARMOI = "VISUALISATION_PASVUPARMOI"
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_VISUALISATION_VUPARMOIETPARTEAM = "VISUALISATION_VUPARMOIETPARTEAM"
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_VISUALISATION_NONVUPARMOIETNONVUPARTEAM = "VISUALISATION_NONVUPARMOIETNONVUPARTEAM"
/* ---- */
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_OPERATEUR_LOGIQUE_OU = "OPERATEUR_LOGIQUE_OU"
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_OPERATEUR_LOGIQUE_ET = "OPERATEUR_LOGIQUE_ET"
/* ---- */
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_KEYWORDTARGET_CV = "KEYWORDTARGET_CV"
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_KEYWORDTARGET_NOM_MAIL_TEL = "KEYWORDTARGET_NOM_MAIL_TEL"
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_KEYWORDTARGET_SUIVI = "KEYWORDTARGET_SUIVI"
/* ---- */
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_SUIVI_AVEC_MON_SUIVI = "SUIVI_AVEC_MON_SUIVI"
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_SUIVI_SANS_MON_SUIVI = "SUIVI_SANS_MON_SUIVI"
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_SUIVI_SANS_MON_SUIVI_NI_CELUI_COEQUIPIERS = "SUIVI_SANS_MON_SUIVI_NI_CELUI_COEQUIPIERS"
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_SUIVI_AVEC_MON_SUIVI_OU_CELUI_COEQUIPIERS = "SUIVI_AVEC_MON_SUIVI_OU_CELUI_COEQUIPIERS"
/* ---- */
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_FRAICHEUR_CV_MOINS_15_JOURS = "FRAICHEUR_CV_MOINS_15_JOURS"
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_FRAICHEUR_CV_MOINS_1_MOIS = "FRAICHEUR_CV_MOINS_1_MOIS"
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_FRAICHEUR_CV_MOINS_2_MOIS = "FRAICHEUR_CV_MOINS_2_MOIS"
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_FRAICHEUR_CV_MOINS_6_MOIS = "FRAICHEUR_CV_MOINS_6_MOIS"
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_FRAICHEUR_CV_MOINS_12_MOIS = "FRAICHEUR_CV_MOINS_12_MOIS"
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_FRAICHEUR_CV_TOUTES = "FRAICHEUR_CV_TOUTES"
/* ---- */
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_TYPE_SAUVEGARDE = "TYPE_SAUVEGARDE"
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_TYPE_HISTORIQUE = "TYPE_HISTORIQUE"

/* ENTITY PersonnelAvecDelegationDroitsConsultant*/
export const CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_CONSULTATION_DDC = "DROIT_CONSULTATION_DDC"
export const CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_VALIDATION_DDC = "DROIT_VALIDATION_DDC"
export const CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_REJET_DDC = "DROIT_REJET_DDC"
export const CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_CONSULTATION_ARRETS_MALADIE = "DROIT_CONSULTATION_ARRETS_MALADIE"
export const CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_GESTION_DECLARATIONS = "DROIT_GESTION_DECLARATIONS"
export const CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_VISUALISATION = "DROIT_VISUALISATION"
export const CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_GESTION_ODM = "DROIT_GESTION_ODM"
export const CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_GESTION_DOCS_COMMERCIAUX = "DROIT_GESTION_DOCS_COMMERCIAUX"
export const CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_GESTION_CONTRAT_TRAVAIL = "DROIT_GESTION_CONTRAT_TRAVAIL"
export const CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_REVIEW_DECLARATIONS = "DROIT_REVIEW_DECLARATIONS"

/* ENTITY Pays */
export const CONST_PAYS_CODE_FRANCE = 250
export const CONST_PAYS_ID_FRANCE = 75

/* ENTITY BusinessUnit */
export const CONST_BUSINESS_UNIT_SECRET_DEFENSE_CODE = "DEFENSE"
export const CONST_BUSINESS_UNIT_AERO_ID = 1
export const CONST_BUSINESS_UNIT_AUTRE_ID = 13

/* ENTITY Candidat_document */
export const CONST_CANDIDAT_DOCUMENT_TYPE_CV = "TYPE_CV"
export const CONST_CANDIDAT_DOCUMENT_TYPE_DOCO = "TYPE_DOSSIER_COMPETENCE"

/* ENTITY Consultant */
// Consultant
// -- etat
export const CONST_CONSULTANT_ETAT_EN_COURS_EMBAUCHE_POUR_MISSION = "ETAT_EN_COURS_EMBAUCHE_POUR_MISSION"
export const CONST_CONSULTANT_ETAT_EN_COURS_EMBAUCHE_SANS_MISSION = "ETAT_EN_COURS_EMBAUCHE_SANS_MISSION"
export const CONST_CONSULTANT_ETAT_EMBAUCHE_AVEC_MISSION = "ETAT_EMBAUCHE_AVEC_MISSION"
export const CONST_CONSULTANT_ETAT_EMBAUCHE_INACTIF = "ETAT_EMBAUCHE_INACTIF"
export const CONST_CONSULTANT_ETAT_HORS_EFFECTIF = "ETAT_HORS_EFFECTIF"
export const CONST_CONSULTANT_ETAT_EMBAUCHE_SANS_MISSION = "ETAT_EMBAUCHE_SANS_MISSION"
// -- statut
export const CONST_CONSULTANT_STATUT_ETAM = "STATUT_ETAM"
export const CONST_CONSULTANT_STATUT_AGENT_MAITRISE = "STATUT_AGENT_MAITRISE"
export const CONST_CONSULTANT_STATUT_CADRE = "STATUT_CADRE"
export const CONST_CONSULTANT_STATUT_ST_PORTAGE = "STATUT_ST_PORTAGE"
export const CONST_CONSULTANT_STATUT_ST_SOCIETE_SERVICE = "STATUT_ST_SOCIETE_SERVICE"
export const CONST_CONSULTANT_STATUT_ST_FREELANCE = "STATUT_ST_FREELANCE"
// -- Contrat
export const CONST_CONSULTANT_CONTRAT_CDI = "CONTRAT_CDI"
export const CONST_CONSULTANT_CONTRAT_CDD = "CONTRAT_CDD"
export const CONST_CONSULTANT_CONTRAT_CDIC = "CONTRAT_CDIC"
export const CONST_CONSULTANT_CONTRAT_ST = "CONTRAT_ST"

/* ENTITY ConsultantDE */
export const CONST_CONSULTANT_DE_DISPOSITIF_POLE_EMPLOI_AFPR = "AFPR"
export const CONST_CONSULTANT_DE_DISPOSITIF_POLE_EMPLOI_PMSMP = "PMSMP"

/* ENTITY ConsultantDocument */
export const CONST_CONSULTANT_DOCUMENT_TYPE_PASSEPORT_CNI = "TYPE_PASSEPORT_CNI"
export const CONST_CONSULTANT_DOCUMENT_TYPE_TITRE_SEJOUR = "TYPE_TITRE_SEJOUR"
export const CONST_CONSULTANT_DOCUMENT_TYPE_ATTESTATION_SS = "TYPE_ATTESTATION_SS"
export const CONST_CONSULTANT_DOCUMENT_TYPE_RIB = "TYPE_RIB"
export const CONST_CONSULTANT_DOCUMENT_TYPE_CONTRAT = "TYPE_CONTRAT"
export const CONST_CONSULTANT_DOCUMENT_TYPE_AVENANT_CONTRAT = "TYPE_AVENANT_CONTRAT"
export const CONST_CONSULTANT_DOCUMENT_TYPE_PERMIS_CONDUIRE = "TYPE_PERMIS_CONDUIRE"
export const CONST_CONSULTANT_DOCUMENT_TYPE_DIPLOME = "TYPE_DIPLOME"
export const CONST_CONSULTANT_DOCUMENT_TYPE_AUTRES = "TYPE_AUTRES"

/* ENTITY PersonnelDocument (workflow d'embauche staff) */
export const CONST_PERSONNEL_DOCUMENT_TYPE_CONTRAT = "TYPE_CONTRAT"
export const CONST_PERSONNEL_DOCUMENT_TYPE_CV = "TYPE_CV"
export const CONST_PERSONNEL_DOCUMENT_TYPE_PASSEPORT_CNI = "TYPE_PASSEPORT_CNI"
export const CONST_PERSONNEL_DOCUMENT_TYPE_ATTESTATION_SS = "TYPE_ATTESTATION_SS"
export const CONST_PERSONNEL_DOCUMENT_TYPE_RIB = "TYPE_RIB"
export const CONST_PERSONNEL_DOCUMENT_TYPE_PERMIS_CONDUIRE = "TYPE_PERMIS_CONDUIRE"
export const CONST_PERSONNEL_DOCUMENT_TYPE_DIPLOME = "TYPE_DIPLOME"
export const CONST_PERSONNEL_DOCUMENT_TYPE_TITRE_SEJOUR = "TYPE_TITRE_SEJOUR"
export const CONST_PERSONNEL_DOCUMENT_TYPE_AUTRES = "TYPE_AUTRES"

/* ENTITY Candidat */
export const CONST_MOBILITE_FRANCE = "MOBILITE_FRANCE"
export const CONST_MOBILITE_FRANCE_HORS_IDF = "MOBILITE_FRANCE_HORS_IDF"
export const CONST_MOBILITE_IDF = "MOBILITE_IDF"
export const CONST_MOBILITE_DEPARTEMENTAL = "MOBILITE_DEPARTEMENTAL"
export const CONST_MOBILITE_REGIONAL = "MOBILITE_REGIONAL"
export const CONST_MOBILITE_PAR_VILLE = "MOBILITE_PAR_VILLE"
export const CONST_MOBILITE_INTERNATIONAL = "MOBILITE_INTERNATIONAL"
export const CONST_CANDIDAT_DISPONIBILITE_DATE_EXACTE = "DISPONIBILITE_DATE_EXACTE"
/* ---- */
export const CONST_CANDIDAT_ETAT_EMBAUCHE = "ETAT_EMBAUCHE"
/* ---- */
export const CONST_CANDIDAT_MOBILITE_DEPARTEMENTAL = "MOBILITE_DEPARTEMENTAL"
export const CONST_CANDIDAT_MOBILITE_REGIONAL = "MOBILITE_REGIONAL"
export const CONST_CANDIDAT_MOBILITE_PAR_VILLE = "MOBILITE_PAR_VILLE"
/* ---- */
export const CONST_CANDIDAT_REMUNERATION_SOUHAITE_FORMAT__BRUT = "REMUNERATION_SOUHAITE_FORMAT__BRUT"
export const CONST_CANDIDAT_REMUNERATION_SOUHAITE_FORMAT__NET = "REMUNERATION_SOUHAITE_FORMAT__NET"
export const CONST_CANDIDAT_REMUNERATION_SOUHAITE_FORMAT__HT = "REMUNERATION_SOUHAITE_FORMAT__HT"
export const CONST_CANDIDAT_REMUNERATION_SOUHAITE_JOUR_OR_MOIS_OR_ANNEE__JOUR = "REMUNERATION_SOUHAITE_JOUR_OR_MOIS_OR_ANNEE__JOUR"
export const CONST_CANDIDAT_REMUNERATION_SOUHAITE_JOUR_OR_MOIS_OR_ANNEE__MOIS = "REMUNERATION_SOUHAITE_JOUR_OR_MOIS_OR_ANNEE__MOIS"
export const CONST_CANDIDAT_REMUNERATION_SOUHAITE_JOUR_OR_MOIS_OR_ANNEE__ANNEE = "REMUNERATION_SOUHAITE_JOUR_OR_MOIS_OR_ANNEE__ANNEE"
/* ---- */
export const CONST_CANDIDAT_TYPE_POSTULANT = "TYPE_POSTULANT"
export const CONST_CANDIDAT_TYPE_CS = "TYPE_CS"
export const CONST_CANDIDAT_TYPE_SAISI = "TYPE_SAISI"
/* ---- */
export const CONST_CANDIDAT_EXPERIENCE_0A1_ANS = "EXPERIENCE_0A1_ANS"
export const CONST_CANDIDAT_EXPERIENCE_1A2_ANS = "EXPERIENCE_1A2_ANS"
export const CONST_CANDIDAT_EXPERIENCE_2A5_ANS = "EXPERIENCE_2A5_ANS"
export const CONST_CANDIDAT_EXPERIENCE_5A7_ANS = "EXPERIENCE_5A7_ANS"
export const CONST_CANDIDAT_EXPERIENCE_7A10_ANS = "EXPERIENCE_7A10_ANS"
export const CONST_CANDIDAT_EXPERIENCE_10A15_ANS = "EXPERIENCE_10A15_ANS"
export const CONST_CANDIDAT_EXPERIENCE_15PLUS_ANS = "EXPERIENCE_15PLUS_ANS"
/* ---- */
export const CONST_NIVEAU_ETUDES_TECHNICIEN = "NIVEAU_ETUDES_TECHNICIEN"
export const CONST_NIVEAU_ETUDES_INGE = "NIVEAU_ETUDES_INGE"
/* ---- */
export const CONST_DISPONIBILITE_IMMEDIATE = "DISPONIBILITE_IMMEDIATE"
export const CONST_DISPONIBILITE_PREAVIS_EN_COURS = "DISPONIBILITE_PREAVIS_EN_COURS"
export const CONST_DISPONIBILITE_PREAVIS_2_SEMAINES = "DISPONIBILITE_PREAVIS_2_SEMAINES"
export const CONST_DISPONIBILITE_PREAVIS_1_MOIS = "DISPONIBILITE_PREAVIS_1_MOIS"
export const CONST_DISPONIBILITE_PREAVIS_2_MOIS = "DISPONIBILITE_PREAVIS_2_MOIS"
export const CONST_DISPONIBILITE_PREAVIS_3_MOIS = "DISPONIBILITE_PREAVIS_3_MOIS"
export const CONST_DISPONIBILITE_DATE_EXACTE = "DISPONIBILITE_DATE_EXACTE"

/* ENTITY CandidatStatus */
export const CONST_CANDIDATSTATUS_CONTACTE_OR_NOT_RETENU_OPTION_NON_RETENU = "CONTACTE_OR_NOT_RETENU_OPTION_NON_RETENU"
export const CONST_CANDIDATSTATUS_CONTACTE_OR_NOT_RETENU_OPTION_CONTACTE = "CONTACTE_OR_NOT_RETENU_OPTION_CONTACTE"
export const CONST_CANDIDATSTATUS_CONTACTE_PAR_EMAIL = "CONTACTE_PAR_EMAIL"
export const CONST_CANDIDATSTATUS_CONTACTE_PAR_TEL = "CONTACTE_PAR_TEL"
export const CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_MOBILITE = "NON_RETENU_CAUSE_MOBILITE"
export const CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_COMPETENCES = "NON_RETENU_CAUSE_COMPETENCES"
export const CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_DISPO = "NON_RETENU_CAUSE_DISPO"
export const CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_REMUNERATION = "NON_RETENU_CAUSE_REMUNERATION"
export const CONST_CANDIDATSTATUS_NON_RETENU_CAUSE_REFUS_CANDIDAT = "NON_RETENU_CAUSE_REFUS_CANDIDAT"
export const CONST_CANDIDATSTATUS_EXPERIENCE_NON_ADAPTEE = "NON_RETENU_CAUSE_EXPERIENCE_NON_ADAPTEE"

/* ENTITY CandidatSuivi*/
export const CONST_CANDIDATSUIVI_TYPE_MESSAGE_REPONDEUR = "TYPE_MESSAGE_REPONDEUR"
export const CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_TELEPHONIQUE = "TYPE_ENTRETIEN_TELEPHONIQUE"
export const CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_CTS = "TYPE_ENTRETIEN_CTS"
export const CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_CLIENT = "TYPE_ENTRETIEN_CLIENT"
export const CONST_CANDIDATSUIVI_TYPE_VISIO = "TYPE_REUNION_VISIO"
export const CONST_CANDIDATSUIVI_TYPE_REUNION_PRESENTIEL = "TYPE_REUNION_PRESENTIEL"
export const CONST_CANDIDATSUIVI_TYPE_DEMANDE_EMBAUCHE = "TYPE_DEMANDE_EMBAUCHE"
export const CONST_CANDIDATSUIVI_TYPE_EMBAUCHE = "TYPE_EMBAUCHE"
export const CONST_CANDIDATSUIVI_TYPE_ADD_TO_VIVIER = "TYPE_ADD_TO_VIVIER"
export const CONST_CANDIDATSUIVI_TYPE_TRANSFERT_PROFIL_PAR_EMAIL = "TYPE_TRANSFERT_PROFIL_PAR_EMAIL"
export const CONST_CANDIDATSUIVI_TYPE_PARTAGER_DOCO_PAR_MAIL = "TYPE_PARTAGER_DOCO_PAR_MAIL"
export const CONST_CANDIDATSUIVI_TYPE_GENERER_DOCO_VIERGE_ET_NOTIFIER_CANDIDAT_PAR_MAIL = "TYPE_GENERER_DOCO_VIERGE_ET_NOTIFIER_CANDIDAT_PAR_MAIL"
export const CONST_CANDIDATSUIVI_TYPE_DEMANDER_INFO_PRE_EMBAUCHE_ENVOI_MAIL = "TYPE_DEMANDER_INFO_PRE_EMBAUCHE_ENVOI_MAIL"
export const CONST_CANDIDATSUIVI_TYPE_RE_DEMANDER_INFO_PRE_EMBAUCHE_ENVOI_MAIL = "TYPE_RE_DEMANDER_INFO_PRE_EMBAUCHE_ENVOI_MAIL"
export const CONST_CANDIDATSUIVI_TYPE_SIMPLE_COMMENTAIRE = "TYPE_SIMPLE_COMMENTAIRE"
export const CONST_CANDIDATSUIVI_TYPE_BLACKLIST_NON_RECOMMANDE = "TYPE_BLACKLIST_NON_RECOMMANDE"

/* ENTITY ConsultantDeclarationMensuelleSuivi */
export const CONST_CONSULTANT_DECLARATION_SUIVI_TYPE_INTERESSE_FINALISATION = "TYPE_INTERESSE_FINALISATION"
export const CONST_CONSULTANT_DECLARATION_SUIVI_TYPE_INTERESSE_SIGNATURE = "TYPE_INTERESSE_SIGNATURE"
export const CONST_CONSULTANT_DECLARATION_SUIVI_TYPE_INTERESSE_RECTIFICATION_SANS_DEMANDE = "TYPE_INTERESSE_RECTIFICATION_SANS_DEMANDE"
export const CONST_CONSULTANT_DECLARATION_SUIVI_TYPE_RESP_DEMANDE_RECTIFICATION = "TYPE_RESP_DEMANDE_RECTIFICATION"
export const CONST_CONSULTANT_DECLARATION_SUIVI_TYPE_RESP_VALIDATION = "TYPE_RESP_VALIDATION"
export const CONST_CONSULTANT_DECLARATION_SUIVI_TYPE_SIEGE_DEMANDE_RECTIFICATION = "TYPE_SIEGE_DEMANDE_RECTIFICATION"
export const CONST_CONSULTANT_DECLARATION_SUIVI_TYPE_SIEGE_VALIDATION = "TYPE_SIEGE_VALIDATION"
export const CONST_CONSULTANT_DECLARATION_SUIVI_TYPE_INTERESSE_DEMANDE_REGUL = "TYPE_INTERESSE_DEMANDE_REGUL"
export const CONST_CONSULTANT_DECLARATION_SUIVI_TYPE_RESP_VALIDATION_REGUL = "TYPE_RESP_VALIDATION_REGUL"
export const CONST_CONSULTANT_DECLARATION_SUIVI_TYPE_RESP_REJET_REGUL = "TYPE_RESP_REJET_REGUL"
export const CONST_CONSULTANT_DECLARATION_SUIVI_TYPE_REVIEW = "TYPE_REVIEW"
export const CONST_CONSULTANT_DECLARATION_SUIVI_TYPE_CANCEL_REVIEW = "TYPE_CANCEL_REVIEW"

/* ENTITY ConsultantDdcSuivi */
export const CONST_DDC_SUIVI_TYPE_ENVOI_DEMANDE = "TYPE_ENVOI_DEMANDE"
export const CONST_DDC_SUIVI_TYPE_ACCEPTATION_DEMANDE = "TYPE_ACCEPTATION_DEMANDE"
export const CONST_DDC_SUIVI_TYPE_RECTIFICATION_PAR_CONSULTANT_AVANT_DECISION_BM = "TYPE_RECTIFICATION_PAR_CONSULTANT_AVANT_DECISION_BM"
export const CONST_DDC_SUIVI_TYPE_REJET_DEMANDE = "TYPE_REJET_DEMANDE"
export const CONST_DDC_SUIVI_TYPE_ANNULATION_DEMANDE = "TYPE_ANNULATION_DEMANDE"

/* ENTITY ConsultantMission*/
export const CONST_CONSULTANT_MISSION_REFERENCE_FORFAIT_GENERIQUE_POUR_CRA = "FORFAIT"
export const CONST_CONSULTANT_MISSION_HORAIRE_CLASSIQUE = "HORAIRE_CLASSIQUE"
export const CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES_MATIN_NUIT = "HORAIRE_ALTERNE_2_PLAGES_MATIN_NUIT"
export const CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES_MATIN_APREM = "HORAIRE_ALTERNE_2_PLAGES_MATIN_APREM"
export const CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_3_PLAGES = "HORAIRE_ALTERNE_3_PLAGES"
export const CONST_CONSULTANT_MISSION_HORAIRE_NUIT_UNIQUEMENT = "HORAIRE_NUIT_UNIQUEMENT"
export const CONST_CONSULTANT_MISSION_HORAIRE_MATIN_UNIQUEMENT = "HORAIRE_MATIN_UNIQUEMENT"
export const CONST_CONSULTANT_MISSION_HORAIRE_APREM_UNIQUEMENT = "HORAIRE_APREM_UNIQUEMENT"
export const CONST_CONSULTANT_MISSION_FREQUENCE_OCCASIONNEL = "FREQUENCE_OCCASIONNEL"
export const CONST_CONSULTANT_MISSION_FREQUENCE_HABITUELLE = "FREQUENCE_HABITUELLE"

/* ENTITY ConsultantDdc*/
export const CONST_DDC_TYPE_CONGES_PAYES = "TYPE_CONGES_PAYES"
export const CONST_DDC_TYPE_CONGES_SANS_SOLDE = "TYPE_CONGES_SANS_SOLDE"
export const CONST_DDC_TYPE_REPOS_COMPENSATEUR = "TYPE_REPOS_COMPENSATEUR"
export const CONST_DDC_TYPE_ABSENCE_AUTORISEE = "TYPE_ABSENCE_AUTORISEE"
export const CONST_DDC_TYPE_ABSENCE_NON_AUTORISEE = "TYPE_ABSENCE_NON_AUTORISEE"
export const CONST_DDC_TYPE_ABSENCE_EXCEPTIONNELLE = "TYPE_ABSENCE_EXCEPTIONNELLE"
export const CONST_DDC_TYPE_ABSENCE_JOUR_NON_TRAVAILLE_FORFAIT = "TYPE_ABSENCE_JOUR_NON_TRAVAILLE_FORFAIT"
export const CONST_DDC_TYPE_ABSENCE_RTT = "ABSENCE_RTT"

export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_MARIAGE = "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_MARIAGE"
export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_PACS = "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_PACS"
export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_MARIAGE_ENFANT = "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_MARIAGE_ENFANT"
export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_NAISSANCE_ENFANT = "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_NAISSANCE_ENFANT"
export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_CONGES_MATERNITE = "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_CONGES_MATERNITE"
export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_CONGES_PATERNITE_UN_ENFANT = "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_CONGES_PATERNITE_UN_ENFANT"
export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_CONGES_PATERNITE_MANY_ENFANT = "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_CONGES_PATERNITE_MANY_ENFANT"
export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_ENFANT_MOINS_25_ANS = "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_ENFANT_MOINS_25_ANS"
export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_ENFANT_PLUS_25_ANS = "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_ENFANT_PLUS_25_ANS"
export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_CONJOINT_CONCUBUN_PARTENAIRE_PACS =
     "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_CONJOINT_CONCUBUN_PARTENAIRE_PACS"
export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_PARENT = "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_PARENT"
export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_PARENTS_CONJOINT_LIE_PAR_MARIAGE =
     "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_PARENTS_CONJOINT_LIE_PAR_MARIAGE"
export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_FRERE_SOEUR = "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_FRERE_SOEUR"
export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_BEAU_PERE_BELLE_MERE_DU_CONJOINT_MARIE_PACS =
     "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_BEAU_PERE_BELLE_MERE_DU_CONJOINT_MARIE_PACS"
export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_ANNONCE_HANDICAP_OU_MALADIE_GRAVE_ENFANT =
     "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_ANNONCE_HANDICAP_OU_MALADIE_GRAVE_ENFANT"
export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_GRAND_PARENT_OU_ARRIERE_GRAND_PARENT =
     "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_GRAND_PARENT_OU_ARRIERE_GRAND_PARENT"
export const CONST_CONSULTANT_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_AUTRE = "SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_AUTRE"

/* ENTITY ConsultantArretMaladie */
export const CONST_CONSULTANT_ARRET_MALADIE_MOTIF_MALADIE = "MALAD"
export const CONST_CONSULTANT_ARRET_MALADIE_MOTIF_ARRET_THERAPEUTIQUE = "ARRET_THERAPEUTIQUE"
export const CONST_CONSULTANT_ARRET_MALADIE_TYPE_TYPE_JOUR = "JOUR"
export const CONST_CONSULTANT_ARRET_MALADIE_TYPE_TYPE_DEMI_MATIN = "DEMI_MATIN"
export const CONST_CONSULTANT_ARRET_MALADIE_TYPE_TYPE_DEMI_APREM = "DEMI_APREM"
export const CONST_CONSULTANT_ARRET_MALADIE_TYPE_TYPE_AUTRE = "AUTRE"

/* ENTITY ConsultantCraDetails*/
export const CONST_CRA_DETAILS_ABSCENCE_CPA = CONST_DDC_TYPE_CONGES_PAYES
export const CONST_CRA_DETAILS_ABSCENCE_CSS = CONST_DDC_TYPE_CONGES_SANS_SOLDE
export const CONST_CRA_DETAILS_ABSCENCE_JOURS_NON_TRAVAILLES_FORFAIT = CONST_DDC_TYPE_ABSENCE_JOUR_NON_TRAVAILLE_FORFAIT
export const CONST_CRA_DETAILS_ABSCENCE_CEX = CONST_DDC_TYPE_ABSENCE_EXCEPTIONNELLE
export const CONST_CRA_DETAILS_ABSCENCE_CMA = "ABSCENCE_CMA"
export const CONST_CRA_DETAILS_ABSCENCE_FERIES = "ABSCENCE_FERIES"
export const CONST_CRA_DETAILS_ABSCENCE_REPOS_COMPENSATEUR = CONST_DDC_TYPE_REPOS_COMPENSATEUR
export const CONST_CRA_DETAILS_ABSCENCE_SFP = "ABSCENCE_SFP"
export const CONST_CRA_DETAILS_ABSCENCE_RTT = CONST_DDC_TYPE_ABSENCE_RTT
export const CONST_CRA_DETAILS_ABSCENCE_AUTORISEE = CONST_DDC_TYPE_ABSENCE_AUTORISEE
export const CONST_CRA_DETAILS_ABSCENCE_NON_AUTORISEE = CONST_DDC_TYPE_ABSENCE_NON_AUTORISEE

/* ENTITY VIVIER */
export const CONST_VIVIER_STATUS_DISPONIBLE = "STATUT_DISPONIBLE"
export const CONST_VIVIER_STATUS_ARCHIVED = "STATUT_ARCHIVED"

/* ENTITY Entite */
export const CONST_ENTITE_CODE_AIRFRAME = "CODE_AIRFRAME"
export const CONST_ENTITE_CODE_AIRSYS = "CODE_AIRSYS"
export const CONST_ENTITE_CODE_AIRSYS_PAU = "CODE_AIRSYS_PAU"
export const CONST_ENTITE_CODE_CTS = "CODE_CTS"
export const CONST_ENTITE_CODE_GS = "CODE_GS"
export const CONST_ENTITE_CODE_IT = "CODE_IT"
export const CONST_ENTITE_CODE_NATESYS = "CODE_NATESYS"
export const CONST_ENTITE_CODE_NEO = "CODE_NEO"
export const CONST_ENTITE_CODE_NORD = "CODE_NORD"
export const CONST_ENTITE_CODE_SENSE = "CODE_SENSE"

/* ENTITY ConsultantNdfDetail */
export const CONST_NDF_DETAILS_CATEGORIE_KM = "CATEGORIE_KM"
export const CONST_NDF_DETAILS_CATEGORIE_CARBURANT = "CATEGORIE_CARBURANT"
export const CONST_NDF_DETAILS_CATEGORIE_PEAGE = "CATEGORIE_PEAGE"
export const CONST_NDF_DETAILS_CATEGORIE_PARKING = "CATEGORIE_PARKING"
export const CONST_NDF_DETAILS_CATEGORIE_AVION = "CATEGORIE_AVION"
export const CONST_NDF_DETAILS_CATEGORIE_TRAIN = "CATEGORIE_TRAIN"
export const CONST_NDF_DETAILS_CATEGORIE_TAXI = "CATEGORIE_TAXI"
export const CONST_NDF_DETAILS_CATEGORIE_TRANSPORT_EN_COMMUN = "CATEGORIE_TRANSPORT_EN_COMMUN"
export const CONST_NDF_DETAILS_CATEGORIE_HOTEL = "CATEGORIE_HOTEL"
export const CONST_NDF_DETAILS_CATEGORIE_REPAS_MIDI = "CATEGORIE_REPAS_MIDI"
export const CONST_NDF_DETAILS_CATEGORIE_REPAS_SOIR = "CATEGORIE_REPAS_SOIR"
export const CONST_NDF_DETAILS_CATEGORIE_DIVERS = "CATEGORIE_DIVERS"
export const CONST_NDF_DETAILS_CATEGORIE_FORFAIT_GRAND_DEPLACEMENT = "CATEGORIE_FORFAIT_GRAND_DEPLACEMENT"

/* ENTITY Fournisseur*/
export const CONST_FOURNISSEUR_FORME_JURIDIQUE_AUTOENTREPREURE = "AUTOENTREPREURE"
export const CONST_FOURNISSEUR_FORME_JURIDIQUE_SAS = "SAS"
export const CONST_FOURNISSEUR_FORME_JURIDIQUE_SASU = "SASU"
export const CONST_FOURNISSEUR_FORME_JURIDIQUE_SARL = "SARL"
export const CONST_FOURNISSEUR_FORME_JURIDIQUE_EURL = "EURL"
export const CONST_FOURNISSEUR_FORME_JURIDIQUE_BICBNC = "BICBNC"
export const CONST_FOURNISSEUR_TYPE_SOCIETE_PORTAGE = "SOCIETE_PORTAGE"
export const CONST_FOURNISSEUR_TYPE_SOCIETE_SERVICE = "SOCIETE_SERVICE"
export const CONST_FOURNISSEUR_TYPE_FREELANCE = "FREELANCE"

/* ENTITY Fournisseur Document*/
export const CONST_FOURNISSEUR_DOCUMENT_EXTRAIT_KBIS = "TYPE_FOURNISSEUR_EXTRAIT_KBIS"
export const CONST_FOURNISSEUR_DOCUMENT_ASSURANCE_RC_PRO = "TYPE_FOURNISSEUR_ASSURANCE_RC_PRO"
export const CONST_FOURNISSEUR_DOCUMENT_VIGILANCE_URSSAF = "TYPE_FOURNISSEUR_VIGILANCE_URSSAF"
export const CONST_FOURNISSEUR_DOCUMENT_REGULARITE_FISCALE = "TYPE_FOURNISSEUR_REGULARITE_FISCALE"
export const CONST_FOURNISSEUR_DOCUMENT_RIB = "TYPE_FOURNISSEUR_RIB"

// ENTITY ClientPropal
export const CONST_CLIENT_PROPAL_ETAT_VALIDEE = "ETAT_VALIDEE"
export const CONST_CLIENT_PROPAL_ETAT_EN_COURS = "ETAT_EN_COURS"
export const CONST_CLIENT_PROPAL_ETAT_REFUSEE = "ETAT_REFUSEE"
export const CONST_CLIENT_PROPAL_ETAT_DISABLED = "ETAT_DISABLED"
export const CONST_CLIENT_PROPAL_ETAT_EN_PROD = "ETAT_EN_PROD"
export const CONST_CLIENT_PROPAL_ETAT_PARTIELLEMENT_LIVRE = "ETAT_PARTIELLEMENT_LIVRE"
export const CONST_CLIENT_PROPAL_ETAT_LIVRE = "ETAT_LIVRE"
export const CONST_CLIENT_PROPAL_TYPE_FORFAIT = "TYPE_FORFAIT"
export const CONST_CLIENT_PROPAL_TYPE_ASSISTANCE_TECHNIQUE = "TYPE_ASSISTANCE_TECHNIQUE"
export const CONST_CLIENT_PROPAL_CATEGORIE_MERE = "CATEGORIE_MERE"
export const CONST_CLIENT_PROPAL_CATEGORIE_FILLE = "CATEGORIE_FILLE"
export const CONST_CLIENT_PROPAL_CATEGORIE_ORPHELINE = "CATEGORIE_ORPHELINE"

// ENTITY ClientBonCommande
export const CONST_CLIENT_BON_COMMANDE_TYPE_MAIL_CONFIRMATION = "TYPE_MAIL_CONFIRMATION"
export const CONST_CLIENT_BON_COMMANDE_TYPE_BC_ORIGINAL = "TYPE_BC_ORIGINAL"

// ENTITY ClientBonLivraison
export const CONST_CLIENT_BON_LIVRAISON_ETAT_REDIGE = "ETAT_REDIGE"
export const CONST_CLIENT_BON_LIVRAISON_ETAT_EN_COURS = "ETAT_EN_COURS"
export const CONST_CLIENT_BON_LIVRAISON_ETAT_ENVOYE_AU_CLIENT = "ETAT_ENVOYE_AU_CLIENT"
export const CONST_CLIENT_BON_LIVRAISON_ETAT_RECU_AVEC_SIGNATURE_CLIENT = "ETAT_RECU_AVEC_SIGNATURE_CLIENT"
export const CONST_CLIENT_BON_LIVRAISON_ETAT_FACTURE = "ETAT_FACTURE"
export const CONST_CLIENT_BON_LIVRAISON_ETAT_PAYE = "ETAT_PAYE"

// ENTITY ConsultantCRaDetails
export const CONST_CONSULTANT_CRA_DETAILS_ETAT_EN_MISSION = "ETAT_EN_MISSION"
export const CONST_CONSULTANT_CRA_DETAILS_ETAT_INACTIF = "ETAT_INACTIF"
export const CONST_CONSULTANT_CRA_DETAILS_ETAT_HORS_EFFECTIF = "ETAT_HORS_EFFECTIF"

// ENTITY ConsultantMission
export const CONST_CONSULTANT_MISSION_TYPE_PERMANENT = "TYPE_PERMANENT"
export const CONST_CONSULTANT_MISSION_TYPE_PONCTUEL = "TYPE_PONCTUEL"
export const CONST_CONSULTANT_MISSION_TYPE_ST = "TYPE_ST"

// ENTITY ConsultantSuivi
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_SOLDE_TOUT_COMPTE = "TYPE_SOLDE_TOUT_COMPTE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_CLIENT = "TYPE_CHANGEMENT_CLIENT"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_ENVOYER_MAIL_INSTRUCTIONS_CONNEXION_ESPACE_COLLAB = "TYPE_ENVOYER_MAIL_INSTRUCTIONS_CONNEXION_ESPACE_COLLAB"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_EVOLUTION_TJMST = "TYPE_EVOLUTION_TJMST"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_EVOLUTION_SALAIRE_BRUT = "TYPE_EVOLUTION_SALAIRE_BRUT"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_MANAGER = "TYPE_CHANGEMENT_MANAGER"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_MACHINE = "TYPE_CHANGEMENT_MACHINE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_AJOUT_DATE_EFD = "TYPE_AJOUT_DATE_EFD"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_AJOUT_PRIME = "TYPE_AJOUT_PRIME"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_AJOUT_REMARQUE = "TYPE_AJOUT_REMARQUE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_COEFF = "TYPE_CHANGEMENT_COEFF"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_POSITION = "TYPE_CHANGEMENT_POSITION"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_HEURESSUPP = "TYPE_CHANGEMENT_HEURESSUPP"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_ENTITE = "TYPE_CHANGEMENT_ENTITE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_ENTITE_FACTURATION = "TYPE_CHANGEMENT_ENTITE_FACTURATION"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_REPORTING = "TYPE_REPORTING"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_REPORTING_VIA_TEL = "TYPE_REPORTING_VIA_TEL"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_REPORTING_SUR_SITE = "TYPE_REPORTING_SUR_SITE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_REPORTING_EN_AGENCE = "TYPE_REPORTING_EN_AGENCE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_CONTRAT = "TYPE_CHANGEMENT_CONTRAT"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_STATUT = "TYPE_CHANGEMENT_STATUT"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_TJM = "TYPE_CHANGEMENT_TJM"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_AJOUT_ODM_PONCTUEL = "TYPE_AJOUT_ODM_PONCTUEL"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_AFFECTATION_MISSION = "TYPE_AFFECTATION_MISSION"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_MISSION = "TYPE_CHANGEMENT_MISSION"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_PROLONGEMENT_MISSION = "TYPE_PROLONGEMENT_MISSION"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_AJOUT_ODM_SIGNE = "TYPE_AJOUT_ODM_SIGNE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_AJOUT_CONTRAT_SIGNE = "TYPE_AJOUT_CONTRAT_SIGNE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_RECEPTION_ODM_SIGNE = "TYPE_RECEPTION_ODM_SIGNE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_RECEPTION_CONTRAT_SIGNE = "TYPE_RECEPTION_CONTRAT_SIGNE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_ANNULATION_RECEPTION_ODM_SIGNE = "TYPE_ANNULATION_RECEPTION_ODM_SIGNE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_ANNULATION_RECEPTION_CONTRAT_SIGNE = "TYPE_ANNULATION_RECEPTION_CONTRAT_SIGNE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_AJOUT_AVENANTCONTRAT_SIGNE = "TYPE_AJOUT_AVENANTCONTRAT_SIGNE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_RECEPTION_AVENANTCONTRAT_SIGNE = "TYPE_RECEPTION_AVENANTCONTRAT_SIGNE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_ANNULATION_RECEPTION_AVENANTCONTRAT_SIGNE = "TYPE_ANNULATION_RECEPTION_AVENANTCONTRAT_SIGNE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_AJOUT_AVENANTCONTRAT = "TYPE_AJOUT_AVENANTCONTRAT"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_BASEFACTURATION = "TYPE_CHANGEMENT_BASEFACTURATION"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_AJOUT_BASEFACTURATION = "TYPE_AJOUT_BASEFACTURATION"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_AJOUT_HEURES_SUPP = "TYPE_AJOUT_HEURES_SUPP"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_FLAG_AS_DELETED = "TYPE_FLAG_AS_DELETED"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_AJOUT_TICKETRESTO = "TYPE_AJOUT_TICKETRESTO"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_SUPPRESSION_TICKETRESTO = "TYPE_SUPPRESSION_TICKETRESTO"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_FAUX_DEPART = "TYPE_FAUX_DEPART"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_ADRESSETRAVAIL = "TYPE_CHANGEMENT_ADRESSETRAVAIL"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_ETAT_TO_INTERCONTRAT = "TYPE_CHANGEMENT_ETAT_TO_INTERCONTRAT"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_ETAT_TO_HORSEFFECTIF = "TYPE_CHANGEMENT_ETAT_TO_HORSEFFECTIF"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_ETAT_TO_ENMISSION = "TYPE_CHANGEMENT_ETAT_TO_ENMISSION"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_AJOUT_MACHINE = "TYPE_AJOUT_MACHINE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_SUPPRESSION_MACHINE = "TYPE_SUPPRESSION_MACHINE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_CHANGEMENT_PERSONNEL_DELEGATION_DROITS = "TYPE_CHANGEMENT_PERSONNEL_DELEGATION_ADMINISTRATIVE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_AJOUTER_PERSONNEL_DELEGATION_DROITS = "TYPE_AJOUTER_PERSONNEL_DELEGATION_DROITS"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_REINITIALISATION_EMBAUCHE = "TYPE_ANNULATION_EDTION_DEMANDE_EMBAUCHE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_PE_DEMANDERENOUVELLEMENT = "TYPE_PE_DEMANDERENOUVELLEMENT"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_PE_CONFIRMATIONENOUVELLEMENT = "TYPE_PE_CONFIRMATIONENOUVELLEMENT"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_PE_PROPOSITION_DATE_RUPTURE_ANTICIPEE = "TYPE_PE_PROPOSITION_DATE_RUPTURE_ANTICIPEE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_PE_DEMANDE_RUPTURE_ANTICIPEE = "TYPE_PE_DEMANDE_RUPTURE_ANTICIPEE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_IGNORER_ENVOI_DOCS_EMBAUCHE = "TYPE_IGNORER_ENVOI_DOCS_EMBAUCHE"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_DEMANDER_INFO_PRE_EMBAUCHE_ENVOI_MAIL = "TYPE_DEMANDER_INFO_PRE_EMBAUCHE_ENVOI_MAIL"
export const CONST_CONSULTANT_SUIVI_GENERAL_TYPE_RE_DEMANDER_INFO_PRE_EMBAUCHE_ENVOI_MAIL = "TYPE_RE_DEMANDER_INFO_PRE_EMBAUCHE_ENVOI_MAIL"

export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_TDB = "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_TDB"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_RECRUTEMENT_ANNONCE = "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_RECRUTEMENT_ANNONCE"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_RECRUTEMENT_CANDIDAT = "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_RECRUTEMENT_CANDIDAT"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_RECRUTEMENT_VIVIER = "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_RECRUTEMENT_VIVIER"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_RECRUTEMENT_DE = "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_RECRUTEMENT_DE"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BUSINESS_PTF = "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BUSINESS_PTF"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BUSINESS_COLLAB = "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BUSINESS_COLLAB"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BUSINESS_CLIENT = "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BUSINESS_CLIENT"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BUSINESS_FOURNISSEUR = "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BUSINESS_FOURNISSEUR"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BUSINESS_BTC = "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BUSINESS_BTC"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_ADMINISTRATIF = "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_ADMINISTRATIF"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_GESTION_PRODUCTION_DECLARATIONS =
     "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_GESTION_PRODUCTION_DECLARATIONS"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_GESTION_PRODUCTION_BL = "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_GESTION_PRODUCTION_BL"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_GESTION_STRUCTURE_LISTE_PERSONNEL =
     "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_GESTION_STRUCTURE_LISTE_PERSONNEL"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_GESTION_STRUCTURE_LISTE_DECLARATION =
     "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_GESTION_STRUCTURE_LISTE_DECLARATION"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_GESTION_STRUCTURE_LISTE_AJOUTER_PERSONNEL =
     "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_GESTION_STRUCTURE_LISTE_AJOUTER_PERSONNEL"
export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BASE_DOCUMENTAIRE = "PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BASE_DOCUMENTAIRE"

/* Entity POSTE_PERSONNEL */
export const CONST_POSTE_PERSONNEL_POSTE_IA = "POSTE_IA"
export const CONST_POSTE_PERSONNEL_POSTE_RESPONSABLE_DEPARTEMENT = "POSTE_RESPONSABLE_DEPARTEMENT"
export const CONST_POSTE_PERSONNEL_POSTE_RESPONSABLE_ACTIVITE = "POSTE_RESPONSABLE_ACTIVITE"
export const CONST_POSTE_PERSONNEL_POSTE_RESPONSABLE_BUREAU_ETUDE = "POSTE_RESPONSABLE_BUREAU_ETUDE"
export const CONST_POSTE_PERSONNEL_POSTE_DIRECTEUR_BU = "POSTE_DIRECTEUR_BU"
export const CONST_POSTE_PERSONNEL_POSTE_DIRECTEUR_AGENCE = "POSTE_DIRECTEUR_AGENCE"
export const CONST_POSTE_PERSONNEL_POSTE_CHARGE_RECRUTEMENT = "POSTE_CHARGE_RECRUTEMENT"
export const CONST_POSTE_PERSONNEL_POSTE_GERANT = "POSTE_GERANT"
export const CONST_POSTE_PERSONNEL_POSTE_CHEF_PROJET = "POSTE_CHEF_PROJET"
export const CONST_POSTE_PERSONNEL_POSTE_ASSISTANT_RH = "POSTE_ASSISTANT_RH"
export const CONST_POSTE_PERSONNEL_POSTE_RH = "POSTE_RH"
export const CONST_POSTE_PERSONNEL_POSTE_RESP_INFORMATIQUE = "POSTE_RESP_INFORMATIQUE"
export const CONST_POSTE_PERSONNEL_POSTE_DG = "POSTE_DG"
export const CONST_POSTE_PERSONNEL_POSTE_PRESIDENT = "POSTE_PRESIDENT"
export const CONST_POSTE_PERSONNEL_POSTE_DAF = "POSTE_DAF"
export const CONST_POSTE_PERSONNEL_POSTE_COMMUNICATION = "POSTE_COMMUNICATION"
export const CONST_POSTE_PERSONNEL_POSTE_COMPTABLE = "POSTE_COMPTABLE"

/* KPI */
export const KPI_NB_CV_SAISI = "KPI_NB_CV_SAISI"
export const KPI_NB_MESSAGE_REPONDEUR_SAISI = "KPI_NB_MESSAGE_REPONDEUR_SAISI"
export const KPI_NB_ENTRETIEN_TELEPHONIQUE_SAISI = "KPI_NB_ENTRETIEN_TELEPHONIQUE_SAISI"
export const KPI_NB_ENTRETIEN_CTS_SAISI = "KPI_NB_ENTRETIEN_CTS_SAISI"
export const KPI_NB_ENTRETIEN_CLIENT_SAISI = "KPI_NB_ENTRETIEN_CLIENT_SAISI"
export const KPI_NB_ANNONCE_ARCHIVE = "KPI_NB_ANNONCE_ARCHIVE"
export const KPI_NB_ANNONCE_CREEE = "KPI_NB_ANNONCE_CREEE"
export const KPI_NB_ANNONCE_REPUBLIE = "KPI_NB_ANNONCE_REPUBLIE"
export const KPI_NB_ENTREES_SORTIES_CONSULTANT = "KPI_NB_ENTREES_SORTIES_CONSULTANT"
export const KPI_INTERCONTRAT_CONSULTANT = "KPI_INTERCONTRAT_CONSULTANT"
export const KPI_EVOLUTION_CA_COUT_MBP = "KPI_EVOLUTION_CA_COUT_MBP"

export const CONST_MONTANT_INDEMNITE_PAR_KM = 0.35

/**************************************************************/
/**************************************************************/
/*                    END API-CORE CONSTANTS                  */
/**************************************************************/
/**************************************************************/

/* REGEX */
export const REGEXP_PHONE = /^(\d{2} \d{2} \d{2} \d{2} \d{2}|\d{2}\d{2}\d{2}\d{2}\d{2})$/
export const REGEXP_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

/* MIME TYPES */
export const CONST_MIME_APPLICATION_JSON = "application/json"
export const CONST_MIME_APPLICATION_XML = "application/xml"
export const CONST_MIME_APPLICATION_PDF = "application/pdf"
export const CONST_MIME_APPLICATION_DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
export const CONST_MIME_APPLICATION_DOC = "application/msword"
export const CONST_MIME_APPLICATION_GOOGLE_DOC = "application/vnd.google-apps.document"
export const CONST_MIME_APPLICATION_ODT = "application/vnd.oasis.opendocument.text"
export const CONST_MIME_APPLICATION_XLS = "application/vnd.ms-excel"
export const CONST_MIME_APPLICATION_XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
export const CONST_MIME_APPLICATION_ODS = "application/vnd.oasis.opendocument.spreadsheet"
export const CONST_MIME_APPLICATION_GOOGLE_SPREADSHEET = "application/vnd.google-apps.spreadsheet"
export const CONST_MIME_APPLICATION_PPT = "application/vnd.ms-powerpoint"
export const CONST_MIME_APPLICATION_PPTX = "application/vnd.openxmlformats-officedocument.presentationml.presentation"
export const CONST_MIME_APPLICATION_ODP = "application/vnd.oasis.opendocument.presentation"
export const CONST_MIME_APPLICATION_GOOGLE_PRESENTATION = "application/vnd.google-apps.presentation"
export const CONST_MIME_IMAGE_JPEG = "image/jpeg"
export const CONST_MIME_IMAGE_JPG = "image/jpg"
export const CONST_MIME_IMAGE_PNG = "image/png"

/* TODO: Consider renaming with a better name */
export const CONST_MOIS_JANVIER = "01"
export const CONST_MOIS_FEVRIER = "02"
export const CONST_MOIS_MARS = "03"
export const CONST_MOIS_AVRIL = "04"
export const CONST_MOIS_MAI = "05"
export const CONST_MOIS_JUIN = "06"
export const CONST_MOIS_JUILLET = "07"
export const CONST_MOIS_AOUT = "08"
export const CONST_MOIS_SEPTEMBRE = "09"
export const CONST_MOIS_OCTOBRE = "10"
export const CONST_MOIS_NOVEMBRE = "11"
export const CONST_MOIS_DECEMBRE = "12"

/* UTILIZED FOR SELECT2 CHOICES. TODO: Consider renaming with a better name */
export const CONST_MOIS_LIST = [
     {
          label: "Janvier",
          value: CONST_MOIS_JANVIER,
     },
     {
          label: "Fevrier",
          value: CONST_MOIS_FEVRIER,
     },
     {
          label: "Mars",
          value: CONST_MOIS_MARS,
     },
     {
          label: "Avril",
          value: CONST_MOIS_AVRIL,
     },
     {
          label: "Mai",
          value: CONST_MOIS_MAI,
     },
     {
          label: "Juin",
          value: CONST_MOIS_JUIN,
     },
     {
          label: "Juillet",
          value: CONST_MOIS_JUILLET,
     },
     {
          label: "Aout",
          value: CONST_MOIS_AOUT,
     },
     {
          label: "Septembre",
          value: CONST_MOIS_SEPTEMBRE,
     },
     {
          label: "Octobre",
          value: CONST_MOIS_OCTOBRE,
     },
     {
          label: "Novembre",
          value: CONST_MOIS_NOVEMBRE,
     },
     {
          label: "Decembre",
          value: CONST_MOIS_DECEMBRE,
     },
]

export const CONST_CANDIDAT_SUIVI_OPTIONS = [
     { value: CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_TELEPHONIQUE, label: "DMS" },
     { value: CONST_CANDIDATSUIVI_TYPE_ENTRETIEN_CLIENT, label: "RQ" },
     { value: CONST_CANDIDATSUIVI_TYPE_MESSAGE_REPONDEUR, label: "Message répondeur" },
     { value: CONST_CANDIDATSUIVI_TYPE_VISIO, label: "Planification d'un entretien Visio" },
     { value: CONST_CANDIDATSUIVI_TYPE_REUNION_PRESENTIEL, label: "Planification d'un entretien en présentiel" },
     { value: CONST_CANDIDATSUIVI_TYPE_DEMANDE_EMBAUCHE, label: "Demanade d'embauche" },
     { value: CONST_CANDIDATSUIVI_TYPE_EMBAUCHE, label: "Embauché" },
     { value: CONST_CANDIDATSUIVI_TYPE_ADD_TO_VIVIER, label: "Ajout dans vivier" },
     { value: CONST_CANDIDATSUIVI_TYPE_TRANSFERT_PROFIL_PAR_EMAIL, label: "Transfert profil par mail" },
     { value: CONST_CANDIDATSUIVI_TYPE_PARTAGER_DOCO_PAR_MAIL, label: "Partage doco par mail" },
     { value: CONST_CANDIDATSUIVI_TYPE_GENERER_DOCO_VIERGE_ET_NOTIFIER_CANDIDAT_PAR_MAIL, label: "Génération doco et notification par mail" },
     { value: CONST_CANDIDATSUIVI_TYPE_DEMANDER_INFO_PRE_EMBAUCHE_ENVOI_MAIL, label: "Demande des info. de pré-embauche" },
     { value: CONST_CANDIDATSUIVI_TYPE_RE_DEMANDER_INFO_PRE_EMBAUCHE_ENVOI_MAIL, label: "Re-demande des info. de pré-embauche" },
     { value: CONST_CANDIDATSUIVI_TYPE_SIMPLE_COMMENTAIRE, label: "Simple commentaire" },
     { value: CONST_CANDIDATSUIVI_TYPE_BLACKLIST_NON_RECOMMANDE, label: "Blacklist / non recommandé" },
]

export const CONST_CIVILITES_OPTIONS_FOR_SELECT2 = [
     {
          label: "Monsieur",
          value: CONST_CIVILITE_MR,
     },
     {
          label: "Madame",
          value: CONST_CIVILITE_MME,
     },
     {
          label: "Non renseignée",
          value: CONST_CIVILITE_NON_RENSEIGNEE,
     },
]

export const CONST_OUI_NON_FOR_SELECT2 = [
     {
          label: "Oui",
          value: true,
     },
     {
          label: "Non",
          value: false,
     },
]

export const CONST_NDF_DETAILS_CATEGORIES_OPTIONS_FOR_SELECT2 = [
     {
          value: CONST_NDF_DETAILS_CATEGORIE_KM,
          label: "indemnités kilométriques",
     },
     {
          value: CONST_NDF_DETAILS_CATEGORIE_CARBURANT,
          label: "Carburant",
     },
     {
          value: CONST_NDF_DETAILS_CATEGORIE_PEAGE,
          label: "Péage",
     },
     {
          value: CONST_NDF_DETAILS_CATEGORIE_PARKING,
          label: "Parking",
     },
     {
          value: CONST_NDF_DETAILS_CATEGORIE_AVION,
          label: "Avion",
     },
     {
          value: CONST_NDF_DETAILS_CATEGORIE_TRANSPORT_EN_COMMUN,
          label: "Transport en commun",
     },
     {
          value: CONST_NDF_DETAILS_CATEGORIE_TRAIN,
          label: "Train",
     },
     {
          value: CONST_NDF_DETAILS_CATEGORIE_TAXI,
          label: "Taxi",
     },
     {
          value: CONST_NDF_DETAILS_CATEGORIE_HOTEL,
          label: "Hôtel",
     },
     {
          value: CONST_NDF_DETAILS_CATEGORIE_REPAS_MIDI,
          label: "Repas midi",
     },
     {
          value: CONST_NDF_DETAILS_CATEGORIE_REPAS_SOIR,
          label: "Repas soir",
     },
     {
          value: CONST_NDF_DETAILS_CATEGORIE_FORFAIT_GRAND_DEPLACEMENT,
          label: "Forfait grand deplacement",
     },
     {
          value: CONST_NDF_DETAILS_CATEGORIE_DIVERS,
          label: "Divers",
     },
]

export const CONST_PERSONNEL_NDF_DETAILS_CATEGORIES_OPTIONS_FOR_SELECT2 = [
     {
          value: CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM,
          label: "Indemnités kilométriques",
     },
     {
          value: CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_CARBURANT,
          label: "Carburant",
     },
     {
          value: CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_PEAGE,
          label: "Péage",
     },
     {
          value: CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_PARKING,
          label: "Parking",
     },
     {
          value: CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_AVION,
          label: "Avion",
     },
     {
          value: CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_TRAIN,
          label: "Train",
     },
     {
          value: CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_TAXI,
          label: "Taxi",
     },
     {
          value: CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_TRANSPORT_EN_COMMUN,
          label: "Transport en commun",
     },
     {
          value: CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_HOTEL,
          label: "Hôtel",
     },
     {
          value: CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_DIVERS,
          label: "Divers",
     },
     {
          value: CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_REPAS_MIDI,
          label: "Repas Midi",
     },
     {
          value: CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_REPAS_SOIR,
          label: "Repas Soir",
     },
     {
          value: CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_FORFAIT_GRAND_DEPLACEMENT,
          label: "Forfait grand deplacement",
     },
]

export const CONST_CONSULTANT_DOCUMENT_TYPES_FOR_SELECT2 = [
     {
          label: "Passport / CNI",
          value: CONST_CONSULTANT_DOCUMENT_TYPE_PASSEPORT_CNI,
     },
     {
          label: "Titre de séjour",
          value: CONST_CONSULTANT_DOCUMENT_TYPE_TITRE_SEJOUR,
     },
     {
          label: "Attestation SS",
          value: CONST_CONSULTANT_DOCUMENT_TYPE_ATTESTATION_SS,
     },
     {
          label: "RIB",
          value: CONST_CONSULTANT_DOCUMENT_TYPE_RIB,
     },
     {
          label: "Permis de conduire",
          value: CONST_CONSULTANT_DOCUMENT_TYPE_PERMIS_CONDUIRE,
     },
     {
          label: "Diplôme",
          value: CONST_CONSULTANT_DOCUMENT_TYPE_DIPLOME,
     },
     {
          label: "Autre",
          value: CONST_CONSULTANT_DOCUMENT_TYPE_AUTRES,
     },
]

export const CONST_NDF_TYPES_FOR_SELECT2 = [
     {
          label: "Congés payés",
          value: CONST_DDC_TYPE_CONGES_PAYES,
     },
     {
          label: "Congés sans solde",
          value: CONST_DDC_TYPE_CONGES_SANS_SOLDE,
     },
     {
          label: "Repos compensateur",
          value: CONST_DDC_TYPE_REPOS_COMPENSATEUR,
     },
     {
          label: "Absence autorisée",
          value: CONST_DDC_TYPE_ABSENCE_AUTORISEE,
     },
     {
          label: "Absence non autorisée",
          value: CONST_DDC_TYPE_ABSENCE_NON_AUTORISEE,
     },
     {
          label: "Absence exceptionnelle",
          value: CONST_DDC_TYPE_ABSENCE_EXCEPTIONNELLE,
     },
]

export const CONST_PERSONNEL_ARRET_MALADIE_MOTIFS_FOR_SELECT2 = [
     {
          label: "Maladie",
          value: CONST_PERSONNEL_ARRET_MALADIE_MOTIF_MALADIE,
     },
     {
          label: "Arrêt thérapeutique",
          value: CONST_PERSONNEL_ARRET_MALADIE_MOTIF_ARRET_THERAPEUTIQUE,
     },
]

export const CONST_PERSONNEL_ARRET_MALADIE_TYPES_FOR_SELECT2 = [
     {
          label: "Jour",
          value: CONST_PERSONNEL_ARRET_MALADIE_TYPE_TYPE_JOUR,
     },
     {
          label: "Demi journée (matin)",
          value: CONST_PERSONNEL_ARRET_MALADIE_TYPE_TYPE_DEMI_MATIN,
     },
     {
          label: "Demi journée (après midi)",
          value: CONST_PERSONNEL_ARRET_MALADIE_TYPE_TYPE_DEMI_APREM,
     },
     {
          label: "Autre",
          value: CONST_PERSONNEL_ARRET_MALADIE_TYPE_TYPE_AUTRE,
     },
]

export const CONST_CONSULTANT_ARRET_MALADIE_MOTIFS_FOR_SELECT2 = [
     {
          label: "Maladie",
          value: CONST_CONSULTANT_ARRET_MALADIE_MOTIF_MALADIE,
     },
     {
          label: "Arrêt thérapeutique",
          value: CONST_CONSULTANT_ARRET_MALADIE_MOTIF_ARRET_THERAPEUTIQUE,
     },
]

export const CONST_CONSULTANT_ARRET_MALADIE_TYPES_FOR_SELECT2 = [
     {
          label: "Jour",
          value: CONST_CONSULTANT_ARRET_MALADIE_TYPE_TYPE_JOUR,
     },
     {
          label: "Demi journée (matin)",
          value: CONST_CONSULTANT_ARRET_MALADIE_TYPE_TYPE_DEMI_MATIN,
     },
     {
          label: "Demi journée (après midi)",
          value: CONST_CONSULTANT_ARRET_MALADIE_TYPE_TYPE_DEMI_APREM,
     },
     {
          label: "Autre",
          value: CONST_CONSULTANT_ARRET_MALADIE_TYPE_TYPE_AUTRE,
     },
]

export const CONST_CONTRATS_FOR_SELECT2 = [
     {
          label: "CDI C",
          value: CONST_CONSULTANT_CONTRAT_CDIC,
     },
     {
          label: "CDI",
          value: CONST_CONSULTANT_CONTRAT_CDI,
     },
     {
          label: "CDD",
          value: CONST_CONSULTANT_CONTRAT_CDD,
     },
     {
          label: "Sous-traitance",
          value: CONST_CONSULTANT_CONTRAT_ST,
     },
]

export const CONST_DISPONIBILITE_OPTIONS_FOR_SELECT2 = [
     {
          label: "Immédiate",
          value: CONST_DISPONIBILITE_IMMEDIATE,
     },
     {
          label: "Préavis en cours",
          value: CONST_DISPONIBILITE_PREAVIS_EN_COURS,
     },
     {
          label: "Préavis de 2 semaines",
          value: CONST_DISPONIBILITE_PREAVIS_2_SEMAINES,
     },
     {
          label: "Préavis de 1 mois",
          value: CONST_DISPONIBILITE_PREAVIS_1_MOIS,
     },
     {
          label: "Préavis de 2 mois",
          value: CONST_DISPONIBILITE_PREAVIS_2_MOIS,
     },
     {
          label: "Préavis de 3 mois",
          value: CONST_DISPONIBILITE_PREAVIS_3_MOIS,
     },
     {
          label: "Date exacte",
          value: CONST_DISPONIBILITE_DATE_EXACTE,
     },
]

export const CONST_CANDIDAT_TYPES_FOR_SELECT2 = [
     {
          label: "Postulant à une annonce",
          value: CONST_CANDIDAT_TYPE_POSTULANT,
     },
     {
          label: "Candidature spontanée",
          value: CONST_CANDIDAT_TYPE_CS,
     },
     {
          label: "Saisi manuellement",
          value: CONST_CANDIDAT_TYPE_SAISI,
     },
]

export const CONST_NIVEAU_ETUDES_OPTIONS_FOR_SELECT2 = [
     {
          label: "Ingénieur",
          value: CONST_NIVEAU_ETUDES_INGE,
     },
     {
          label: "Technicien",
          value: CONST_NIVEAU_ETUDES_TECHNICIEN,
     },
]

export const CONST_CANDIDAT_EXPERIENCES_OPTIONS_FOR_SELECT2 = [
     {
          label: "0-1 an",
          value: CONST_CANDIDAT_EXPERIENCE_0A1_ANS,
     },
     {
          label: "1-2 ans",
          value: CONST_CANDIDAT_EXPERIENCE_1A2_ANS,
     },
     {
          label: "2-5 ans",
          value: CONST_CANDIDAT_EXPERIENCE_2A5_ANS,
     },
     {
          label: "5-7 ans",
          value: CONST_CANDIDAT_EXPERIENCE_5A7_ANS,
     },
     {
          label: "7-10 ans",
          value: CONST_CANDIDAT_EXPERIENCE_7A10_ANS,
     },
     {
          label: "10-15 ans",
          value: CONST_CANDIDAT_EXPERIENCE_10A15_ANS,
     },
     {
          label: "+ 15 ans",
          value: CONST_CANDIDAT_EXPERIENCE_15PLUS_ANS,
     },
]

export const CONST_CANDIDAT_DOCUMENT_TYPES_FOR_SELECT2 = [
     {
          label: "Curriculum",
          value: CONST_CANDIDAT_DOCUMENT_TYPE_CV,
     },
]

export const CONST_MOBILITE_OPTIONS_FOR_SELECT2 = [
     {
          label: "Par ville",
          value: CONST_MOBILITE_PAR_VILLE,
     },
     {
          label: "Départemental",
          value: CONST_MOBILITE_DEPARTEMENTAL,
     },
     {
          label: "Régional",
          value: CONST_MOBILITE_REGIONAL,
     },
     {
          label: "Île de France",
          value: CONST_MOBILITE_IDF,
     },
     {
          label: "Province",
          value: CONST_MOBILITE_FRANCE_HORS_IDF,
     },
     {
          label: "International",
          value: CONST_MOBILITE_INTERNATIONAL,
     },
     {
          label: "France",
          value: CONST_MOBILITE_FRANCE,
     },
]

export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_OPERATEURS_LOGIQUE_OPTIONS_FOR_SELECT2 = [
     {
          label: "ET",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_OPERATEUR_LOGIQUE_ET,
     },
     {
          label: "OU",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_OPERATEUR_LOGIQUE_OU,
     },
]

export const CONST_CANDIDAT_REMUNERATION_SOUHAITE_BRUT_NET_OPTIONS = [
     {
          label: "Brut",
          value: CONST_CANDIDAT_REMUNERATION_SOUHAITE_FORMAT__BRUT,
     },
     {
          label: "Net",
          value: CONST_CANDIDAT_REMUNERATION_SOUHAITE_FORMAT__NET,
     },
     {
          label: "Hors taxe",
          value: CONST_CANDIDAT_REMUNERATION_SOUHAITE_FORMAT__HT,
     },
]

export const CONST_CANDIDAT_REMUNERATION_SOUHAITE_JOUR_OR_MOIS_OR_ANNEE_OPTIONS = [
     {
          label: "Par an",
          value: CONST_CANDIDAT_REMUNERATION_SOUHAITE_JOUR_OR_MOIS_OR_ANNEE__ANNEE,
     },
     {
          label: "Par mois",
          value: CONST_CANDIDAT_REMUNERATION_SOUHAITE_JOUR_OR_MOIS_OR_ANNEE__MOIS,
     },
     {
          label: "Par jour",
          value: CONST_CANDIDAT_REMUNERATION_SOUHAITE_JOUR_OR_MOIS_OR_ANNEE__JOUR,
     },
]

export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_VISUALISATIONS_OPTIONS_FOR_SELECT2 = [
     {
          label: "Candidats que je n'ai pas vu",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_VISUALISATION_PASVUPARMOI,
     },
     {
          label: "Candidats vus par moi et ma team",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_VISUALISATION_VUPARMOIETPARTEAM,
     },
     {
          label: "Candidats non vus par moi ou ma team",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_VISUALISATION_NONVUPARMOIETNONVUPARTEAM,
     },
]

export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_KEYWORD_TARGETS_OPTIONS_FOR_SELECT2 = [
     {
          label: "CV uniquement",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_KEYWORDTARGET_CV,
     },
     {
          label: "nom, mail ou téléphone",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_KEYWORDTARGET_NOM_MAIL_TEL,
     },
     {
          label: "suivi",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_KEYWORDTARGET_SUIVI,
     },
]
export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_SUIVIS_OPTIONS_FOR_SELECT2 = [
     {
          label: "candidats avec mon suivi",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_SUIVI_AVEC_MON_SUIVI,
     },
     {
          label: "candidats sans mon suivi",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_SUIVI_SANS_MON_SUIVI,
     },
     {
          label: "candidats sans mon suivi ou celui de mes co-équipiers",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_SUIVI_SANS_MON_SUIVI_NI_CELUI_COEQUIPIERS,
     },
     {
          label: "candidats avec mon suivi ou celui de mes co-équipiers",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_SUIVI_AVEC_MON_SUIVI_OU_CELUI_COEQUIPIERS,
     },
]

export const CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_FRAICHEURS_CV_OPTIONS_FOR_SELECT2 = [
     {
          label: "Candidature de moins de 15 jours",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_FRAICHEUR_CV_MOINS_15_JOURS,
     },
     {
          label: "Candidature de moins de 1 mois",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_FRAICHEUR_CV_MOINS_1_MOIS,
     },
     {
          label: "Candidature de moins de 2 mois",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_FRAICHEUR_CV_MOINS_2_MOIS,
     },
     {
          label: "Candidature de moins de 6 mois",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_FRAICHEUR_CV_MOINS_6_MOIS,
     },
     {
          label: "Candidature de moins de 12 mois",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_FRAICHEUR_CV_MOINS_12_MOIS,
     },
     {
          label: "Toutes les candidatures",
          value: CONST_PERSONNEL_RECHERCHE_CANDIDAT_HISTORIQUE_SAUVEGARDE_FRAICHEUR_CV_TOUTES,
     },
]

export const CONST_ANNONCE_ETATS_OPTIONS_FOR_SELECT2 = [
     {
          label: "Brouillon",
          value: CONST_ANNONCE_ETAT_ON_CREATION,
     },
     {
          label: "En ligne",
          value: CONST_ANNONCE_ETAT_ACTIVE,
     },
     {
          label: "Archivée",
          value: CONST_ANNONCE_ETAT_ARCHIVED,
     },
]

export const CONST_CONSULTANT_STATUTS_OPTIONS_FOR_SELECT2 = [
     {
          label: "ETAM",
          value: CONST_CONSULTANT_STATUT_ETAM,
     },
     {
          label: "Agent de maîtrise",
          value: CONST_CONSULTANT_STATUT_AGENT_MAITRISE,
     },
     {
          label: "Cadre",
          value: CONST_CONSULTANT_STATUT_CADRE,
     },
     {
          label: "Porté",
          value: CONST_CONSULTANT_STATUT_ST_PORTAGE,
     },
     {
          label: "Freelance",
          value: CONST_CONSULTANT_STATUT_ST_FREELANCE,
     },
     {
          label: "Société de service",
          value: CONST_CONSULTANT_STATUT_ST_SOCIETE_SERVICE,
     },
]

export const CONST_PERSONNEL_STATUTS_OPTIONS_FOR_SELECT2 = [
     {
          label: "ETAM",
          value: CONST_PERSONNEL_STATUT_STATUT_ETAM,
     },
     {
          label: "Agent de maîtrise",
          value: CONST_PERSONNEL_STATUT_STATUT_AGENT_MAITRISE,
     },
     {
          label: "Cadre",
          value: CONST_PERSONNEL_STATUT_STATUT_CADRE,
     },
     {
          label: "Non salarié",
          value: CONST_PERSONNEL_STATUT_STATUT_NON_SALARIE,
     },
]

export const CONST_PERSONNEL_CONTRATS_OPTIONS_FOR_SELECT2 = [
     {
          label: "CDI",
          value: CONST_PERSONNEL_CONTRAT_CDI,
     },
     {
          label: "Stage",
          value: CONST_PERSONNEL_CONTRAT_STAGE,
     },
     {
          label: "CDD",
          value: CONST_PERSONNEL_CONTRAT_CDD,
     },
     {
          label: "Alternance",
          value: CONST_PERSONNEL_CONTRAT_ALTERNANCE,
     },
     {
          label: "Contrat non salarié",
          value: CONST_PERSONNEL_CONTRAT_NON_SALARIE,
     },
]

export const CONST_PERSONNEL_DDC_TYPES_FOR_SELECT2 = [
     { label: "Congés payés", value: CONST_PERSONNEL_DDC_TYPE_CONGES_PAYES },
     { label: "Congés sans solde", value: CONST_PERSONNEL_DDC_TYPE_CONGES_SANS_SOLDE },
     { label: "Repos compensateur", value: CONST_PERSONNEL_DDC_TYPE_REPOS_COMPENSATEUR },
     { label: "Absence autorisée", value: CONST_PERSONNEL_DDC_TYPE_ABSENCE_AUTORISEE },
     { label: "Absence non autorisée", value: CONST_PERSONNEL_DDC_TYPE_ABSENCE_NON_AUTORISEE },
     { label: "Absence exceptionnelle", value: CONST_PERSONNEL_DDC_TYPE_ABSENCE_EXCEPTIONNELLE },
     { label: "RTT", value: CONST_PERSONNEL_DDC_TYPE_ABSENCE_RTT },
]

export const CONST_PERSONNEL_CRA_DETAILS_ABSENCE_TYPES_FOR_SELECT2 = [
     { label: "Congés payés", value: CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_CPA },
     { label: "RTT", value: CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_RTT },
     { label: "Absence autorisée", value: CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_AUTORISEE },
     { label: "Absence non autorisée", value: CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_NON_AUTORISEE },
     { label: "Férié", value: CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_FERIES },
     { label: "Maladie", value: CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_CMA },
     { label: "Congés exceptionnels", value: CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_CEX },
     { label: "Repos compensateur", value: CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_REPOS_COMPENSATEUR },
     { label: "Stage de formation", value: CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_SFP },
     { label: "Congés sans solde", value: CONST_PERSONNEL_CRA_DETAILS_ABSCENCE_CSS },
]

export const CONST_PERSONNEL_DDC_SOUS_TYPES_FOR_SELECT2 = [
     { label: "Mariage", value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_MARIAGE },
     { label: "PACS", value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_PACS },
     { label: "Mariage d'un enfant", value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_MARIAGE_ENFANT },
     { label: "Congé maternité", value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_CONGES_MATERNITE },
     { label: "Naissance enfant (paternité)", value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_NAISSANCE_ENFANT },
     { label: "Congé paternité (un enfant)", value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_CONGES_PATERNITE_UN_ENFANT },
     { label: "Congé paternité (plusieurs enfant)", value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_CONGES_PATERNITE_MANY_ENFANT },
     { label: "Décès d'un enfant de moins de 25 ans", value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_ENFANT_MOINS_25_ANS },
     { label: "Décès d'un enfant de plus de 25 ans", value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_ENFANT_PLUS_25_ANS },
     { label: "Décès du conjoint ou concubin ou partenaire de PACS", value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_CONJOINT_CONCUBUN_PARTENAIRE_PACS },
     { label: "Décès parents", value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_PARENT },
     { label: "Décès des parents du conjoint lié par le mariage", value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_PARENTS_CONJOINT_LIE_PAR_MARIAGE },
     { label: "Décès frère/soeur", value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_FRERE_SOEUR },
     {
          label: "Décès beau-père/belle-mère (du conjoint marié ou pacsé)",
          value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_BEAU_PERE_BELLE_MERE_DU_CONJOINT_MARIE_PACS,
     },
     {
          label: "Annonce de la survenue d'un handicap ou maladie grave chez un enfant",
          value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_ANNONCE_HANDICAP_OU_MALADIE_GRAVE_ENFANT,
     },
     { label: "Décès grands-parents/ arrière-grands-parents", value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_DECES_GRAND_PARENT_OU_ARRIERE_GRAND_PARENT },
     { label: "Autre", value: CONST_PERSONNEL_DDC_SOUS_TYPE_ABSENCE_EXCEPTIONNELLE_AUTRE },
]

export const CONST_FOURNISSEUR_FORMES_JURIDIQUE_OPTIONS_FOR_SELECT2 = [
     {
          label: "Auto-entrepreneur",
          value: CONST_FOURNISSEUR_FORME_JURIDIQUE_AUTOENTREPREURE,
     },
     {
          label: "SAS",
          value: CONST_FOURNISSEUR_FORME_JURIDIQUE_SAS,
     },
     {
          label: "SASU",
          value: CONST_FOURNISSEUR_FORME_JURIDIQUE_SASU,
     },
     {
          label: "SARL",
          value: CONST_FOURNISSEUR_FORME_JURIDIQUE_SARL,
     },
     {
          label: "EURL",
          value: CONST_FOURNISSEUR_FORME_JURIDIQUE_EURL,
     },
     {
          label: "BIC/BNC",
          value: CONST_FOURNISSEUR_FORME_JURIDIQUE_BICBNC,
     },
]

export const CONST_FOURNISSEUR_TYPES_OPTIONS_FOR_SELECT2 = [
     {
          label: "Société de portage salarial",
          value: CONST_FOURNISSEUR_TYPE_SOCIETE_PORTAGE,
     },
     {
          label: "Freelance (entreprise unipersonnelle)",
          value: CONST_FOURNISSEUR_TYPE_FREELANCE,
     },
     {
          label: "Société de service (ESN, SSII ...)",
          value: CONST_FOURNISSEUR_TYPE_SOCIETE_SERVICE,
     },
]

export const CONST_VIVIER_STATUS_OPTIONS_FOR_SELECT2 = [
     {
          label: "Disponible",
          value: CONST_VIVIER_STATUS_DISPONIBLE,
     },
     {
          label: "Archivé",
          value: CONST_VIVIER_STATUS_ARCHIVED,
     },
]

export const CONST_PERSONNEL_CRA_DETAILS_HEURE_TYPES_OPTIONS_FOR_SELECT2 = [
     {
          label: "Principale",
          value: CONST_PERSONNEL_CRA_DETAILS_HEURE_TYPE_DEFAULT,
     },
     {
          label: "TT",
          value: CONST_PERSONNEL_CRA_DETAILS_HEURE_TYPE_TT,
     },
     {
          label: "École",
          value: CONST_PERSONNEL_CRA_DETAILS_HEURE_TYPE_ECOLE,
     },
]

// OPTIONS FOR SELECT2
//CONST_CONSULTANT_MISSION_HORAIRE_CLASSIQUE
// CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES
// CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_3_PLAGES
// CONST_CONSULTANT_MISSION_HORAIRE_NUIT_UNIQUEMENT
// CONST_CONSULTANT_MISSION_HORAIRE_MATIN_UNIQUEMENT
// CONST_CONSULTANT_MISSION_HORAIRE_APREM_UNIQUEMENT
export const CONST_CONSULTANT_MISSION_HORAIRE_OPTIONS_FOR_SELECT2 = [
     {
          label: "Classique (matin et après-midi)",
          value: CONST_CONSULTANT_MISSION_HORAIRE_CLASSIQUE,
     },
     {
          label: "2-8 (matin et nuit)",
          value: CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES_MATIN_NUIT,
     },
     {
          label: "2-8 (matin et après-midi)",
          value: CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_2_PLAGES_MATIN_APREM,
     },
     {
          label: "3-8 (3 plages horaires)",
          value: CONST_CONSULTANT_MISSION_HORAIRE_ALTERNE_3_PLAGES,
     },
     {
          label: "Nuit uniquement",
          value: CONST_CONSULTANT_MISSION_HORAIRE_NUIT_UNIQUEMENT,
     },
     {
          label: "Matin uniquement",
          value: CONST_CONSULTANT_MISSION_HORAIRE_MATIN_UNIQUEMENT,
     },
     {
          label: "Après-midi uniquement",
          value: CONST_CONSULTANT_MISSION_HORAIRE_APREM_UNIQUEMENT,
     },
]

export const CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROITS_OPTIONS_FOR_SELECT2 = [
     { value: CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_CONSULTATION_DDC, label: "Consultation des DDC" },
     { value: CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_VALIDATION_DDC, label: "Validation des DDC" },
     { value: CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_REJET_DDC, label: "Rejet des DDC" },
     { value: CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_CONSULTATION_ARRETS_MALADIE, label: "Consultation des Arrêts maladie" },
     { value: CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_GESTION_DECLARATIONS, label: "Gestion des déclarations" },
     { value: CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_VISUALISATION, label: "Consultation de la fiche consultant (limité)" },
     { value: CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_GESTION_ODM, label: "Gestion des ODM" },
     { value: CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_GESTION_DOCS_COMMERCIAUX, label: "Gestion des documents commerciaux" },
     { value: CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_GESTION_CONTRAT_TRAVAIL, label: "Gestion des contrats de travail" },
     { value: CONST_PERSONNEL_AVEC_DELEGATION_DROITS_CONSULTANT__DROIT_REVIEW_DECLARATIONS, label: "Pré-validation des déclarations" },
]

export const CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_OPTIONS_FOR_SELECT2 = [
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_TDB, label: "Tableau de bord" },
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_RECRUTEMENT_ANNONCE, label: "Annonces" },
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_RECRUTEMENT_CANDIDAT, label: "Candidats" },
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_RECRUTEMENT_VIVIER, label: "Viviers" },
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_RECRUTEMENT_DE, label: "Demandes d'embauche" },
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BUSINESS_PTF, label: "PTF" },
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BUSINESS_COLLAB, label: "Consultants" },
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BUSINESS_CLIENT, label: "Clients" },
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BUSINESS_FOURNISSEUR, label: "Fournisseurs" },
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BUSINESS_BTC, label: "Cost tool" },
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_ADMINISTRATIF, label: "Administratif" },
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_GESTION_PRODUCTION_DECLARATIONS, label: "Production déclarations" },
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_GESTION_PRODUCTION_BL, label: "Production BL" },
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_GESTION_STRUCTURE_LISTE_PERSONNEL, label: "Structure gestion du staff" },
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_GESTION_STRUCTURE_LISTE_DECLARATION, label: "Structure déclarations" },
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_GESTION_STRUCTURE_LISTE_AJOUTER_PERSONNEL, label: "Structure ajout personnel" },
     { value: CONST_PERSONNEL_APPLICATION_ACCESS_MENU_TARGET_MODULE_BASE_DOCUMENTAIRE, label: "Drive" },
]

export const CONST_KPI_LIST_OPTIONS_FOR_SELECT2 = [
     { value: KPI_NB_CV_SAISI, label: "Nombre de CV saisis" },
     { value: KPI_NB_MESSAGE_REPONDEUR_SAISI, label: "Nombre de messages répondeur saisis" },
     { value: KPI_NB_ENTRETIEN_TELEPHONIQUE_SAISI, label: "Nombre d'entretiens téléphonique saisis" },
     { value: KPI_NB_ENTRETIEN_CTS_SAISI, label: "Nombre d'entretiens CTS saisis" },
     { value: KPI_NB_ENTRETIEN_CLIENT_SAISI, label: "Nombre d'entretiens client saisis" },
     { value: KPI_NB_ANNONCE_ARCHIVE, label: "Nombre d'annonces archivés" },
     { value: KPI_NB_ANNONCE_CREEE, label: "Nombre d'annonces créées" },
     { value: KPI_NB_ANNONCE_REPUBLIE, label: "Nombre d'annonces republiées" },
     { value: KPI_NB_ENTREES_SORTIES_CONSULTANT, label: "Évolution des effectifs" },
     { value: KPI_INTERCONTRAT_CONSULTANT, label: "Intercontrats" },
     { value: KPI_EVOLUTION_CA_COUT_MBP, label: "Évolution du coût, CA et MBP" },
]

export const CONST_USER_PERMISSIONS_OPTIONS_FOR_SELECT2 = [
     { value: CONST_USER_PERMISSION_UPDATES_VIEW, label: "Journal des mises à jour" },
     { value: CONST_USER_PERMISSION_ANNUAIRE_VIEW, label: "Annuaire" },
     { value: CONST_USER_PERMISSION_GOOGLE_APPS_VIEW, label: "Google Apps" },
     { value: CONST_USER_PERMISSION_OUTILS_VIEW, label: "Outils" },
     { value: CONST_USER_PERMISSION_OUTILS_COST_TOOL_VIEW, label: "Outils - Cost Tool" },
     { value: CONST_USER_PERMISSION_OUTILS_SIGNATURE_VIEW, label: "Outils - Signature" },
     { value: CONST_USER_PERMISSION_OUTILS_EXPORTS_VIEW, label: "Outils - Exports" },
     { value: CONST_USER_PERMISSION_OUTILS_PDF_UTILS_VIEW, label: "Outils - PDF Utils" },
     { value: CONST_USER_PERMISSION_TDB_VIEW, label: "Tableau de bord" },
     { value: CONST_USER_PERMISSION_TDB_ALERTES_VIEW, label: "Tableau de bord - Alertes" },
     { value: CONST_USER_PERMISSION_TDB_INDICATEURS_VIEW, label: "Tableau de bord - Indicateurs" },
     { value: CONST_USER_PERMISSION_AI_USAGE_VIEW, label: "Usage IA" },
     { value: CONST_USER_PERMISSION_DECLARATIONS_VIEW, label: "Déclarations" },
     { value: CONST_USER_PERMISSION_RECRUTEMENT_VIEW, label: "Recrutement" },
     { value: CONST_USER_PERMISSION_RECRUTEMENT_ANNONCES_VIEW, label: "Recrutement - Annonces" },
     { value: CONST_USER_PERMISSION_RECRUTEMENT_CANDIDATS_VIEW, label: "Recrutement - Candidats" },
     { value: CONST_USER_PERMISSION_RECRUTEMENT_VIVIERS_VIEW, label: "Recrutement - Viviers" },
     { value: CONST_USER_PERMISSION_RECRUTEMENT_DEMANDE_EMBAUCHE_VIEW, label: "Recrutement - Demandes d'embauche" },
     { value: CONST_USER_PERMISSION_BUSINESS_VIEW, label: "Business" },
     { value: CONST_USER_PERMISSION_BUSINESS_PTF_VIEW, label: "Business - PTF" },
     { value: CONST_USER_PERMISSION_BUSINESS_COLLAB_VIEW, label: "Business - Collaborateurs" },
     { value: CONST_USER_PERMISSION_BUSINESS_CLIENT_VIEW, label: "Business - Clients" },
     { value: CONST_USER_PERMISSION_BUSINESS_FOURNISSEUR_VIEW, label: "Business - Fournisseurs" },
     { value: CONST_USER_PERMISSION_ADMINISTRATION_VIEW, label: "Administration" },
     { value: CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_VIEW, label: "Administration - Production" },
     { value: CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_DECLARATIONS_VIEW, label: "Admin - Production - Gestion Déclarations" },
     { value: CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_DDC_VIEW, label: "Admin - Production - Gestion DDC" },
     { value: CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_ARRETS_MALADIE_VIEW, label: "Admin - Production - Gestion Arrêts Maladie" },
     { value: CONST_USER_PERMISSION_ADMINISTRATION_PRODUCTION_GESTION_BL_VIEW, label: "Admin - Production - Gestion BL" },
     { value: CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_VIEW, label: "Admin - Structure" },
     { value: CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW, label: "Admin - Structure - Gestion Staff (full access)" },
     { value: CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_RESTRICTED, label: "Admin - Structure - Gestion Staff (RH - restreint)" },
     { value: CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_VIEW_MANAGER, label: "Admin - Structure - Gestion Staff (manager - subordonnés)" },
     { value: CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_STAFF_ADD_VIEW, label: "Admin - Structure - Ajouter Staff" },
     { value: CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_DECLARATIONS_VIEW, label: "Admin - Structure - Gestion Déclarations" },
     { value: CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_DDC_VIEW, label: "Admin - Structure - Gestion DDC" },
     { value: CONST_USER_PERMISSION_ADMINISTRATION_STRUCTURE_GESTION_ARRETS_MALADIE_VIEW, label: "Admin - Structure - Gestion Arrêts Maladie" },
     { value: CONST_USER_PERMISSION_ADMINISTRATION_ASSURANCES_VIEW, label: "Administration - Assurances" },
     { value: CONST_USER_PERMISSION_RESSOURCES_VIEW, label: "Ressources" },
     { value: CONST_USER_PERMISSION_RESSOURCES_BIBLIOTHEQUE_VIEW, label: "Ressources - Bibliothèque" },
     { value: CONST_USER_PERMISSION_RESSOURCES_DOCUMENTS_EMBAUCHE_VIEW, label: "Ressources - Documents d'embauche" },
]

/* LIBS DEFAULT CUSTOM CONFIGURATION */
export const CONST_DEFAULT_TOAST_OPTIONS: ToastOptions = {
     position: "bottom-right",
     autoClose: 2000,
     hideProgressBar: false,
     closeOnClick: true,
     pauseOnHover: true,
     transition: Slide,
     draggable: true,
     theme: "light",
}
